const Upazilas = [
    { "id": "1", "district_id": "1", "name": "Alikadam", "bn_name": "দেবিদ্বার", "url": "debidwar.comilla.gov.bd" },
    { "id": "2", "district_id": "1", "name": "Balaghata", "bn_name": "বরুড়া", "url": "barura.comilla.gov.bd" },
    { "id": "3", "district_id": "1", "name": "Bandarban Sadar", "bn_name": "ব্রাহ্মণপাড়া", "url": "brahmanpara.comilla.gov.bd" },
    { "id": "4", "district_id": "1", "name": "Naikhong", "bn_name": "চান্দিনা", "url": "chandina.comilla.gov.bd" },
    { "id": "5", "district_id": "1", "name": "Naikhongchari", "bn_name": "চৌদ্দগ্রাম", "url": "chauddagram.comilla.gov.bd" },
    { "id": "6", "district_id": "1", "name": "Roanchhari", "bn_name": "দাউদকান্দি", "url": "daudkandi.comilla.gov.bd" },
    { "id": "7", "district_id": "1", "name": "Ruma", "bn_name": "হোমনা", "url": "homna.comilla.gov.bd" },
    { "id": "8", "district_id": "1", "name": "Thanchi", "bn_name": "লাকসাম", "url": "laksam.comilla.gov.bd" },
    { "id": "9", "district_id": "1", "name": "Thanchi Lama", "bn_name": "মুরাদনগর", "url": "muradnagar.comilla.gov.bd" },

    { "id": "18", "district_id": "2", "name": "Haliapara", "bn_name": "ছাগলনাইয়া", "url": "chhagalnaiya.feni.gov.bd" },
    { "id": "19", "district_id": "2", "name": "Jaldi Banigram", "bn_name": "ফেনী সদর", "url": "sadar.feni.gov.bd" },
    { "id": "20", "district_id": "2", "name": "Jaldi Gunagari", "bn_name": "সোনাগাজী", "url": "sonagazi.feni.gov.bd" },
    { "id": "21", "district_id": "2", "name": "Jaldi Khan Bahadur", "bn_name": "ফুলগাজী", "url": "fulgazi.feni.gov.bd" },
    { "id": "22", "district_id": "2", "name": "Jaldi Sadar", "bn_name": "পরশুরাম", "url": "parshuram.feni.gov.bd" },
    { "id": "23", "district_id": "2", "name": "Kalamarchara", "bn_name": "দাগনভূঞা", "url": "daganbhuiyan.feni.gov.bd" },
    { "id": "23", "district_id": "2", "name": "Matarbari", "bn_name": "দাগনভূঞা", "url": "daganbhuiyan.feni.gov.bd" },
    { "id": "23", "district_id": "2", "name": "Napora", "bn_name": "দাগনভূঞা", "url": "daganbhuiyan.feni.gov.bd" },
    { "id": "23", "district_id": "2", "name": "Panirchara", "bn_name": "দাগনভূঞা", "url": "daganbhuiyan.feni.gov.bd" },
    { "id": "23", "district_id": "2", "name": "Sonadia", "bn_name": "দাগনভূঞা", "url": "daganbhuiyan.feni.gov.bd" },

    { "id": "24", "district_id": "3", "name": "Basurhat Basur Hat", "bn_name": "ব্রাহ্মণবাড়িয়া সদর", "url": "sadar.brahmanbaria.gov.bd" },
    { "id": "25", "district_id": "3", "name": "Basurhat Charhajari", "bn_name": "কসবা", "url": "kasba.brahmanbaria.gov.bd" },

    { "id": "33", "district_id": "4", "name": "Begumganj Alaiarpur", "bn_name": "রাঙ্গামাটি সদর", "url": "sadar.rangamati.gov.bd" },
    { "id": "34", "district_id": "4", "name": "Begumganj Amisha Para", "bn_name": "কাপ্তাই", "url": "kaptai.rangamati.gov.bd" },
    { "id": "35", "district_id": "4", "name": "Begumganj Banglabazar", "bn_name": "কাউখালী", "url": "kawkhali.rangamati.gov.bd" },
    { "id": "36", "district_id": "4", "name": "Begumganj Bazra", "bn_name": "বাঘাইছড়ি", "url": "baghaichari.rangamati.gov.bd" },
    { "id": "37", "district_id": "4", "name": "Begumganj Bhabani Jibanpur", "bn_name": "বরকল", "url": "barkal.rangamati.gov.bd" },
    { "id": "38", "district_id": "4", "name": "Begumganj Choumohani", "bn_name": "লংগদু", "url": "langadu.rangamati.gov.bd" },
    { "id": "39", "district_id": "4", "name": "Begumganj Dauti", "bn_name": "রাজস্থলী", "url": "rajasthali.rangamati.gov.bd" },
    { "id": "40", "district_id": "4", "name": "Begumganj Durgapur", "bn_name": "বিলাইছড়ি", "url": "belaichari.rangamati.gov.bd" },
    { "id": "41", "district_id": "4", "name": "Begumganj Gopalpur", "bn_name": "জুরাছড়ি", "url": "juraichari.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Jamidar Hat", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Joyag", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Joynarayanpur", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Khalafat Bazar", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Khalishpur", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Maheshganj", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Mir Owarishpur", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Nadona", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Nandiapara", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Oachhekpur", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Rajganj", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Sadar", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Sonaimuri", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Tangirpar", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },
    { "id": "42", "district_id": "4", "name": "Begumganj Thanar Hat", "bn_name": "নানিয়ারচর", "url": "naniarchar.rangamati.gov.bd" },

    { "id": "43", "district_id": "5", "name": "Bilaichhari Bilaichhari", "bn_name": "নোয়াখালী সদর", "url": "sadar.noakhali.gov.bd" },

    { "id": "52", "district_id": "6", "name": "Boalkhali Charandwip", "bn_name": "হাইমচর", "url": "haimchar.chandpur.gov.bd" },
    { "id": "53", "district_id": "6", "name": "Boalkhali Iqbal Park", "bn_name": "কচুয়া", "url": "kachua.chandpur.gov.bd" },
    { "id": "54", "district_id": "6", "name": "Boalkhali Kadurkhal", "bn_name": "শাহরাস্তি\t", "url": "shahrasti.chandpur.gov.bd" },
    { "id": "55", "district_id": "6", "name": "Boalkhali Kanungopara", "bn_name": "চাঁদপুর সদর", "url": "sadar.chandpur.gov.bd" },
    { "id": "56", "district_id": "6", "name": "Boalkhali Sadar", "bn_name": "মতলব দক্ষিণ", "url": "matlabsouth.chandpur.gov.bd" },
    { "id": "57", "district_id": "6", "name": "Boalkhali Sakpura", "bn_name": "হাজীগঞ্জ", "url": "hajiganj.chandpur.gov.bd" },
    { "id": "58", "district_id": "6", "name": "Boalkhali Saroatoli", "bn_name": "মতলব উত্তর", "url": "matlabnorth.chandpur.gov.bd" },

    { "id": "60", "district_id": "7", "name": "Akhaura", "bn_name": "লক্ষ্মীপুর সদর", "url": "sadar.lakshmipur.gov.bd" },
    { "id": "61", "district_id": "7", "name": "Akhaura Gangasagar", "bn_name": "কমলনগর", "url": "kamalnagar.lakshmipur.gov.bd" },
    { "id": "62", "district_id": "7", "name": "Banchharampur", "bn_name": "রায়পুর", "url": "raipur.lakshmipur.gov.bd" },
    { "id": "63", "district_id": "7", "name": "Bhadughar", "bn_name": "রামগতি", "url": "ramgati.lakshmipur.gov.bd" },
    { "id": "64", "district_id": "7", "name": "Bijoynagar", "bn_name": "রামগঞ্জ", "url": "ramganj.lakshmipur.gov.bd" },
    { "id": "64", "district_id": "7", "name": "Brahmanbaria Sadar", "bn_name": "রামগঞ্জ", "url": "ramganj.lakshmipur.gov.bd" },
    { "id": "64", "district_id": "7", "name": "Brahmanbaria Sadar Ashuganj", "bn_name": "রামগঞ্জ", "url": "ramganj.lakshmipur.gov.bd" },
    { "id": "64", "district_id": "7", "name": "Brahmanbaria Sadar Ashuganj Share", "bn_name": "রামগঞ্জ", "url": "ramganj.lakshmipur.gov.bd" },
    { "id": "64", "district_id": "7", "name": "Brahmanbaria Sadar Poun", "bn_name": "রামগঞ্জ", "url": "ramganj.lakshmipur.gov.bd" },
    { "id": "64", "district_id": "7", "name": "Brahmanbaria Sadar Talshahar", "bn_name": "রামগঞ্জ", "url": "ramganj.lakshmipur.gov.bd" },
    { "id": "64", "district_id": "7", "name": "Gokarna Ghat", "bn_name": "রামগঞ্জ", "url": "ramganj.lakshmipur.gov.bd" },
    { "id": "64", "district_id": "7", "name": "Harashpur", "bn_name": "রামগঞ্জ", "url": "ramganj.lakshmipur.gov.bd" },
    { "id": "64", "district_id": "7", "name": "Hujur Bari", "bn_name": "রামগঞ্জ", "url": "ramganj.lakshmipur.gov.bd" },
    { "id": "64", "district_id": "7", "name": "Nasirnagar", "bn_name": "রামগঞ্জ", "url": "ramganj.lakshmipur.gov.bd" },
    { "id": "64", "district_id": "7", "name": "Natai", "bn_name": "রামগঞ্জ", "url": "ramganj.lakshmipur.gov.bd" },
    { "id": "64", "district_id": "7", "name": "Suhilpur", "bn_name": "রামগঞ্জ", "url": "ramganj.lakshmipur.gov.bd" },

    { "id": "65", "district_id": "8", "name": "Kasba Chandidar", "bn_name": "রাঙ্গুনিয়া", "url": "rangunia.chittagong.gov.bd" },
    { "id": "66", "district_id": "8", "name": "Kasba Chargachh", "bn_name": "সীতাকুন্ড", "url": "sitakunda.chittagong.gov.bd" },
    { "id": "67", "district_id": "8", "name": "Kasba Gopinathpur", "bn_name": "মীরসরাই", "url": "mirsharai.chittagong.gov.bd" },
    { "id": "68", "district_id": "8", "name": "Kasba Kuti", "bn_name": "পটিয়া", "url": "patiya.chittagong.gov.bd" },
    { "id": "69", "district_id": "8", "name": "Kasba Sadar", "bn_name": "সন্দ্বীপ", "url": "sandwip.chittagong.gov.bd" },
    { "id": "70", "district_id": "8", "name": "Kullapathar", "bn_name": "বাঁশখালী", "url": "banshkhali.chittagong.gov.bd" },
    { "id": "71", "district_id": "8", "name": "Boalkhali", "bn_name": "বোয়ালখালী", "url": "boalkhali.chittagong.gov.bd" },
    { "id": "72", "district_id": "8", "name": "Madla", "bn_name": "আনোয়ারা", "url": "anwara.chittagong.gov.bd" },

    { "id": "80", "district_id": "9", "name": "Nabinagar Jibanganj", "bn_name": "কক্সবাজার সদর", "url": "sadar.coxsbazar.gov.bd" },
    { "id": "81", "district_id": "9", "name": "Nabinagar Kaitala", "bn_name": "চকরিয়া", "url": "chakaria.coxsbazar.gov.bd" },
    { "id": "82", "district_id": "9", "name": "Nabinagar Laubfatehpur", "bn_name": "কুতুবদিয়া", "url": "kutubdia.coxsbazar.gov.bd" },
    { "id": "83", "district_id": "9", "name": "Nabinagar Rasullabad", "bn_name": "উখিয়া", "url": "ukhiya.coxsbazar.gov.bd" },
    { "id": "84", "district_id": "9", "name": "Nabinagar Ratanpur", "bn_name": "মহেশখালী", "url": "moheshkhali.coxsbazar.gov.bd" },
    { "id": "85", "district_id": "9", "name": "Nabinagar Sadar", "bn_name": "পেকুয়া", "url": "pekua.coxsbazar.gov.bd" },
    { "id": "86", "district_id": "9", "name": "Nabinagar Salimganj", "bn_name": "রামু", "url": "ramu.coxsbazar.gov.bd" },
    { "id": "87", "district_id": "9", "name": "Nabinagar Shahapur", "bn_name": "টেকনাফ", "url": "teknaf.coxsbazar.gov.bd" },
    { "id": "87", "district_id": "9", "name": "Nabinagar Shamgram", "bn_name": "টেকনাফ", "url": "teknaf.coxsbazar.gov.bd" },
    { "id": "87", "district_id": "9", "name": "Nasirnagar Fandauk", "bn_name": "টেকনাফ", "url": "teknaf.coxsbazar.gov.bd" },

    { "id": "88", "district_id": "10", "name": "Sarail Chandura", "bn_name": "খাগড়াছড়ি সদর", "url": "sadar.khagrachhari.gov.bd" },
    { "id": "89", "district_id": "10", "name": "Sarail Sadar", "bn_name": "দিঘীনালা", "url": "dighinala.khagrachhari.gov.bd" },
    { "id": "90", "district_id": "10", "name": "Sarail Shahbajpur", "bn_name": "পানছড়ি", "url": "panchari.khagrachhari.gov.bd" },

    { "id": "97", "district_id": "11", "name": "Chakaria Sadar", "bn_name": "বান্দরবান সদর", "url": "sadar.bandarban.gov.bd" },
    { "id": "98", "district_id": "11", "name": "Chiringga Badarkali", "bn_name": "আলীকদম", "url": "alikadam.bandarban.gov.bd" },
    { "id": "99", "district_id": "11", "name": "Chiringga Chiringga S.O", "bn_name": "নাইক্ষ্যংছড়ি", "url": "naikhongchhari.bandarban.gov.bd" },
    { "id": "100", "district_id": "11", "name": "Chiringga Malumghat", "bn_name": "রোয়াংছড়ি", "url": "rowangchhari.bandarban.gov.bd" },
    { "id": "101", "district_id": "11", "name": "Chiringga Sadar", "bn_name": "লামা", "url": "lama.bandarban.gov.bd" },
    { "id": "102", "district_id": "11", "name": "Dulahazara", "bn_name": "রুমা", "url": "ruma.bandarban.gov.bd" },
    { "id": "103", "district_id": "11", "name": "Harbang", "bn_name": "থানচি", "url": "thanchi.bandarban.gov.bd" },
    { "id": "103", "district_id": "11", "name": "Khutakhali Bazar", "bn_name": "থানচি", "url": "thanchi.bandarban.gov.bd" },

    { "id": "104", "district_id": "12", "name": "East Joara Barma", "bn_name": "বেলকুচি", "url": "belkuchi.sirajganj.gov.bd" },
    { "id": "105", "district_id": "12", "name": "East Joara Dohazari", "bn_name": "চৌহালি", "url": "chauhali.sirajganj.gov.bd" },
    { "id": "106", "district_id": "12", "name": "East Joara East Joara", "bn_name": "কামারখন্দ", "url": "kamarkhand.sirajganj.gov.bd" },
    { "id": "107", "district_id": "12", "name": "East Joara Gachbaria", "bn_name": "কাজীপুর", "url": "kazipur.sirajganj.gov.bd" },

    { "id": "113", "district_id": "13", "name": "Bedpur", "bn_name": "সুজানগর", "url": "sujanagar.pabna.gov.bd" },
    { "id": "114", "district_id": "13", "name": "Kachua Rahima Nagar", "bn_name": "ঈশ্বরদী", "url": "ishurdi.pabna.gov.bd" },
    { "id": "115", "district_id": "13", "name": "Kachua Sadar", "bn_name": "ভাঙ্গুড়া", "url": "bhangura.pabna.gov.bd" },
    { "id": "116", "district_id": "13", "name": "Kachua Shachar", "bn_name": "পাবনা সদর", "url": "pabnasadar.pabna.gov.bd" },

    { "id": "122", "district_id": "14", "name": "Hajiganj Bolakhal", "bn_name": "কাহালু", "url": "kahaloo.bogra.gov.bd" },
    { "id": "123", "district_id": "14", "name": "Hajiganj Hajiganj", "bn_name": "বগুড়া সদর", "url": "sadar.bogra.gov.bd" },

    { "id": "134", "district_id": "15", "name": "Amuakandi", "bn_name": "পবা", "url": "paba.rajshahi.gov.bd" },
    { "id": "135", "district_id": "15", "name": "Dakkhin Doulotpur", "bn_name": "দুর্গাপুর", "url": "durgapur.rajshahi.gov.bd" },
    { "id": "136", "district_id": "15", "name": "Dakkhin Narayanpur", "bn_name": "মোহনপুর", "url": "mohonpur.rajshahi.gov.bd" },
    { "id": "137", "district_id": "15", "name": "Matlab Mohanpur", "bn_name": "চারঘাট", "url": "charghat.rajshahi.gov.bd" },
    { "id": "138", "district_id": "15", "name": "Matlab Sadar", "bn_name": "পুঠিয়া", "url": "puthia.rajshahi.gov.bd" },
    { "id": "139", "district_id": "15", "name": "Matlab Uttar Amiyapur", "bn_name": "বাঘা", "url": "bagha.rajshahi.gov.bd" },
    { "id": "140", "district_id": "15", "name": "Matlab Uttar Upazila Parishad", "bn_name": "গোদাগাড়ী", "url": "godagari.rajshahi.gov.bd" },
    { "id": "141", "district_id": "15", "name": "Noyanogor", "bn_name": "তানোর", "url": "tanore.rajshahi.gov.bd" },
    { "id": "142", "district_id": "15", "name": "Sujatpur Bazar", "bn_name": "বাগমারা", "url": "bagmara.rajshahi.gov.bd" },

    { "id": "143", "district_id": "16", "name": "Chandpur Chowrasta", "bn_name": "নাটোর সদর", "url": "natoresadar.natore.gov.bd" },
    { "id": "144", "district_id": "16", "name": "Chandpur Sadar Baburhat", "bn_name": "সিংড়া", "url": "singra.natore.gov.bd" },
    { "id": "145", "district_id": "16", "name": "Chandpur Sadar Puranbazar", "bn_name": "বড়াইগ্রাম", "url": "baraigram.natore.gov.bd" },
    { "id": "146", "district_id": "16", "name": "Chandpur Sadar Sahatali", "bn_name": "বাগাতিপাড়া", "url": "bagatipara.natore.gov.bd" },

    { "id": "150", "district_id": "17", "name": "Chatkhil Bansa Bazar", "bn_name": "আক্কেলপুর", "url": "akkelpur.joypurhat.gov.bd" },
    { "id": "151", "district_id": "17", "name": "Chatkhil Bodalcourt", "bn_name": "কালাই", "url": "kalai.joypurhat.gov.bd" },
    { "id": "152", "district_id": "17", "name": "Chatkhil Dosh Gharia", "bn_name": "ক্ষেতলাল", "url": "khetlal.joypurhat.gov.bd" },
    { "id": "153", "district_id": "17", "name": "Chatkhil Karihati", "bn_name": "পাঁচবিবি", "url": "panchbibi.joypurhat.gov.bd" },
    { "id": "154", "district_id": "17", "name": "Chatkhil Khilpara", "bn_name": "জয়পুরহাট সদর", "url": "joypurhatsadar.joypurhat.gov.bd" },
    { "id": "154", "district_id": "17", "name": "Chatkhil Palla", "bn_name": "জয়পুরহাট সদর", "url": "joypurhatsadar.joypurhat.gov.bd" },
    { "id": "154", "district_id": "17", "name": "Chatkhil Rezzakpur", "bn_name": "জয়পুরহাট সদর", "url": "joypurhatsadar.joypurhat.gov.bd" },
    { "id": "154", "district_id": "17", "name": "Chatkhil SadarChatkhil Sadar", "bn_name": "জয়পুরহাট সদর", "url": "joypurhatsadar.joypurhat.gov.bd" },
    { "id": "154", "district_id": "17", "name": "Chatkhil Sahapur", "bn_name": "জয়পুরহাট সদর", "url": "joypurhatsadar.joypurhat.gov.bd" },
    { "id": "154", "district_id": "17", "name": "Chatkhil Sampara", "bn_name": "জয়পুরহাট সদর", "url": "joypurhatsadar.joypurhat.gov.bd" },
    { "id": "154", "district_id": "17", "name": "Chatkhil Shingbahura", "bn_name": "জয়পুরহাট সদর", "url": "joypurhatsadar.joypurhat.gov.bd" },
    { "id": "154", "district_id": "17", "name": "Chatkhil Solla", "bn_name": "জয়পুরহাট সদর", "url": "joypurhatsadar.joypurhat.gov.bd" },

    { "id": "155", "district_id": "18", "name": "Anawara Battali", "bn_name": "চাঁপাইনবাবগঞ্জ সদর", "url": "chapainawabganjsadar.chapainawabganj.gov.bd" },
    { "id": "156", "district_id": "18", "name": "Anawara Paroikora", "bn_name": "গোমস্তাপুর", "url": "gomostapur.chapainawabganj.gov.bd" },
    { "id": "157", "district_id": "18", "name": "Chatory", "bn_name": "নাচোল", "url": "nachol.chapainawabganj.gov.bd" },

    { "id": "160", "district_id": "19", "name": "Agrabad", "bn_name": "মহাদেবপুর", "url": "mohadevpur.naogaon.gov.bd" },
    { "id": "161", "district_id": "19", "name": "AK Khan", "bn_name": "বদলগাছী", "url": "badalgachi.naogaon.gov.bd" },
    { "id": "162", "district_id": "19", "name": "Al- Amin Baria Madrasa", "bn_name": "পত্নিতলা", "url": "patnitala.naogaon.gov.bd" },
    { "id": "163", "district_id": "19", "name": "Amin Jute Mills", "bn_name": "ধামইরহাট", "url": "dhamoirhat.naogaon.gov.bd" },
    { "id": "164", "district_id": "19", "name": "Anandabazar", "bn_name": "নিয়ামতপুর", "url": "niamatpur.naogaon.gov.bd" },
    { "id": "165", "district_id": "19", "name": "Bayezid Bostami", "bn_name": "মান্দা", "url": "manda.naogaon.gov.bd" },
    { "id": "166", "district_id": "19", "name": "Cepz", "bn_name": "আত্রাই", "url": "atrai.naogaon.gov.bd" },
    { "id": "167", "district_id": "19", "name": "Chandgaon", "bn_name": "রাণীনগর", "url": "raninagar.naogaon.gov.bd" },
    { "id": "168", "district_id": "19", "name": "Chattogram Airport", "bn_name": "নওগাঁ সদর", "url": "naogaonsadar.naogaon.gov.bd" },
    { "id": "169", "district_id": "19", "name": "Chattogram Bandar", "bn_name": "পোরশা", "url": "porsha.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Chattogram Cantonment", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Chattogram Customs Acca", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Chattogram GPO", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Chattogram New Market", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Chattogram Politechnic Institute", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Chattogram Sailers Colony", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Chawkbazar", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Colonel Hat", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Combined Military Hospital (CMH)", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Dakkshin Pahartoli", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Double Mooring", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Firozshah", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "GEC", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Jaldia Marine Academy", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Khulshi", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Kotwali", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Middle Patenga", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Mohard", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Nasirabad", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "North Halishahar", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "North Kattali", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Noyabazar", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Oxygen", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Pahartoli", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Panchlaish", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Patenga", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Rampura TSO", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Sadarghat", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "South Halishahar", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "South Kattali", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },
    { "id": "170", "district_id": "19", "name": "Wazedia", "bn_name": "সাপাহার", "url": "sapahar.naogaon.gov.bd" },

    { "id": "171", "district_id": "20", "name": "Amjad Hat", "bn_name": "মণিরামপুর", "url": "manirampur.jessore.gov.bd" },
    { "id": "172", "district_id": "20", "name": "Bangla Bazar Haripur", "bn_name": "অভয়নগর", "url": "abhaynagar.jessore.gov.bd" },
    { "id": "173", "district_id": "20", "name": "Bondua Dolotpur", "bn_name": "বাঘারপাড়া", "url": "bagherpara.jessore.gov.bd" },
    { "id": "174", "district_id": "20", "name": "Box Mahmud", "bn_name": "চৌগাছা", "url": "chougachha.jessore.gov.bd" },
    { "id": "175", "district_id": "20", "name": "Chhagalnaia Daraga Hat", "bn_name": "ঝিকরগাছা", "url": "jhikargacha.jessore.gov.bd" },
    { "id": "176", "district_id": "20", "name": "Chhagalnaia Maharajganj", "bn_name": "কেশবপুর", "url": "keshabpur.jessore.gov.bd" },
    { "id": "177", "district_id": "20", "name": "Chhagalnaia Puabashimulia", "bn_name": "যশোর সদর", "url": "sadar.jessore.gov.bd" },
    { "id": "178", "district_id": "20", "name": "Chhagalnaia Sadar", "bn_name": "শার্শা", "url": "sharsha.jessore.gov.bd" },
    { "id": "178", "district_id": "20", "name": "Kalbat Bottoli Bazar", "bn_name": "শার্শা", "url": "sharsha.jessore.gov.bd" },
    { "id": "178", "district_id": "20", "name": "Killadighi", "bn_name": "শার্শা", "url": "sharsha.jessore.gov.bd" },
    { "id": "178", "district_id": "20", "name": "Puraton Muhuriganj Bazar", "bn_name": "শার্শা", "url": "sharsha.jessore.gov.bd" },
    { "id": "178", "district_id": "20", "name": "Rezumia Bazar", "bn_name": "শার্শা", "url": "sharsha.jessore.gov.bd" },
    { "id": "178", "district_id": "20", "name": "Shantir Bazar", "bn_name": "শার্শা", "url": "sharsha.jessore.gov.bd" },

    { "id": "179", "district_id": "21", "name": "Barura Murdafarganj", "bn_name": "আশাশুনি", "url": "assasuni.satkhira.gov.bd" },
    { "id": "180", "district_id": "21", "name": "Barura Poyalgachha", "bn_name": "দেবহাটা", "url": "debhata.satkhira.gov.bd" },
    { "id": "181", "district_id": "21", "name": "Barura Sadar", "bn_name": "কলারোয়া", "url": "kalaroa.satkhira.gov.bd" },

    { "id": "186", "district_id": "22", "name": "Bagra", "bn_name": "মুজিবনগর", "url": "mujibnagar.meherpur.gov.bd" },
    { "id": "187", "district_id": "22", "name": "Brahmanpara Sadar", "bn_name": "মেহেরপুর সদর", "url": "meherpursadar.meherpur.gov.bd" },
    { "id": "188", "district_id": "22", "name": "Chandla", "bn_name": "গাংনী", "url": "gangni.meherpur.gov.bd" },
    { "id": "188", "district_id": "22", "name": "Shashidal", "bn_name": "গাংনী", "url": "gangni.meherpur.gov.bd" },
    { "id": "188", "district_id": "22", "name": "Shidlai", "bn_name": "গাংনী", "url": "gangni.meherpur.gov.bd" },

    { "id": "189", "district_id": "23", "name": "Adbarpur", "bn_name": "নড়াইল সদর", "url": "narailsadar.narail.gov.bd" },
    { "id": "190", "district_id": "23", "name": "Burichang Maynamoti bazar", "bn_name": "লোহাগড়া", "url": "lohagara.narail.gov.bd" },
    { "id": "191", "district_id": "23", "name": "Burichang Sadar", "bn_name": "কালিয়া", "url": "kalia.narail.gov.bd" },

    { "id": "192", "district_id": "24", "name": "Chandina Chandia", "bn_name": "চুয়াডাঙ্গা সদর", "url": "chuadangasadar.chuadanga.gov.bd" },
    { "id": "193", "district_id": "24", "name": "Chandina Madhaiabazar", "bn_name": "আলমডাঙ্গা", "url": "alamdanga.chuadanga.gov.bd" },
    { "id": "194", "district_id": "24", "name": "Raj Kalibari", "bn_name": "দামুড়হুদা", "url": "damurhuda.chuadanga.gov.bd" },

    { "id": "196", "district_id": "25", "name": "Chouddagram Batisa", "bn_name": "কুষ্টিয়া সদর", "url": "kushtiasadar.kushtia.gov.bd" },
    { "id": "197", "district_id": "25", "name": "Chouddagram Chiora", "bn_name": "কুমারখালী", "url": "kumarkhali.kushtia.gov.bd" },
    { "id": "198", "district_id": "25", "name": "Chouddagram Upazila Health Complex", "bn_name": "খোকসা", "url": "khoksa.kushtia.gov.bd" },

    { "id": "202", "district_id": "26", "name": "Daudkandi Dashpara", "bn_name": "শালিখা", "url": "shalikha.magura.gov.bd" },
    { "id": "203", "district_id": "26", "name": "Daudkandi Daudkandi", "bn_name": "শ্রীপুর", "url": "sreepur.magura.gov.bd" },
    { "id": "204", "district_id": "26", "name": "Daudkandi Eliotganj", "bn_name": "মাগুরা সদর", "url": "magurasadar.magura.gov.bd" },
    { "id": "205", "district_id": "26", "name": "Daudkandi Gouripur", "bn_name": "মহম্মদপুর", "url": "mohammadpur.magura.gov.bd" },

    { "id": "206", "district_id": "27", "name": "Companiganj", "bn_name": "পাইকগাছা", "url": "paikgasa.khulna.gov.bd" },
    { "id": "207", "district_id": "27", "name": "Davidhar Barashalghar", "bn_name": "ফুলতলা", "url": "fultola.khulna.gov.bd" },
    { "id": "208", "district_id": "27", "name": "Davidhar Davidhar", "bn_name": "দিঘলিয়া", "url": "digholia.khulna.gov.bd" },
    { "id": "209", "district_id": "27", "name": "Davidhar Dhamtee", "bn_name": "রূপসা", "url": "rupsha.khulna.gov.bd" },
    { "id": "210", "district_id": "27", "name": "Davidhar Gangamandal", "bn_name": "তেরখাদা", "url": "terokhada.khulna.gov.bd" },


    { "id": "215", "district_id": "28", "name": "Akhandapur", "bn_name": "ফকিরহাট", "url": "fakirhat.bagerhat.gov.bd" },
    { "id": "216", "district_id": "28", "name": "Homna Homna", "bn_name": "বাগেরহাট সদর", "url": "sadar.bagerhat.gov.bd" },
    { "id": "217", "district_id": "28", "name": "Hujurkandi", "bn_name": "মোল্লাহাট", "url": "mollahat.bagerhat.gov.bd" },
    { "id": "218", "district_id": "28", "name": "Mohonpur", "bn_name": "শরণখোলা", "url": "sarankhola.bagerhat.gov.bd" },


    { "id": "224", "district_id": "29", "name": "Gajimura", "bn_name": "ঝিনাইদহ সদর", "url": "sadar.jhenaidah.gov.bd" },
    { "id": "225", "district_id": "29", "name": "Laksam Bipulasar", "bn_name": "শৈলকুপা", "url": "shailkupa.jhenaidah.gov.bd" },
    { "id": "226", "district_id": "29", "name": "Laksam Lakshamanpur", "bn_name": "হরিণাকুন্ডু", "url": "harinakundu.jhenaidah.gov.bd" },

    { "id": "230", "district_id": "30", "name": "Amratali", "bn_name": "ঝালকাঠি সদর", "url": "sadar.jhalakathi.gov.bd" },
    { "id": "231", "district_id": "30", "name": "Baghmara", "bn_name": "কাঠালিয়া", "url": "kathalia.jhalakathi.gov.bd" },
    { "id": "232", "district_id": "30", "name": "Lalmai Pahar", "bn_name": "নলছিটি", "url": "nalchity.jhalakathi.gov.bd" },
    { "id": "233", "district_id": "30", "name": "Poranpur", "bn_name": "রাজাপুর", "url": "rajapur.jhalakathi.gov.bd" },

    { "id": "234", "district_id": "31", "name": "Langalkot Chhariabazar", "bn_name": "বাউফল", "url": "bauphal.patuakhali.gov.bd" },
    { "id": "235", "district_id": "31", "name": "Langalkot Chilpara", "bn_name": "পটুয়াখালী সদর", "url": "sadar.patuakhali.gov.bd" },
    { "id": "236", "district_id": "31", "name": "Langalkot Dhalua", "bn_name": "দুমকি", "url": "dumki.patuakhali.gov.bd" },
    { "id": "237", "district_id": "31", "name": "Langalkot Gunabati", "bn_name": "দশমিনা", "url": "dashmina.patuakhali.gov.bd" },


    { "id": "242", "district_id": "32", "name": "Boro Kanda", "bn_name": "পিরোজপুর সদর", "url": "sadar.pirojpur.gov.bd" },
    { "id": "243", "district_id": "32", "name": "Chandanpur", "bn_name": "নাজিরপুর", "url": "nazirpur.pirojpur.gov.bd" },
    { "id": "244", "district_id": "32", "name": "Manikar Char", "bn_name": "কাউখালী", "url": "kawkhali.pirojpur.gov.bd" },
    { "id": "245", "district_id": "32", "name": "Meghna Luter Char", "bn_name": "জিয়ানগর", "url": "zianagar.pirojpur.gov.bd" },
    { "id": "246", "district_id": "32", "name": "Rampur Bazar", "bn_name": "ভান্ডারিয়া", "url": "bhandaria.pirojpur.gov.bd" },
    { "id": "247", "district_id": "32", "name": "Titir Char", "bn_name": "মঠবাড়ীয়া", "url": "mathbaria.pirojpur.gov.bd" },
    { "id": "248", "district_id": "32", "name": "Vaor Khola", "bn_name": "নেছারাবাদ", "url": "nesarabad.pirojpur.gov.bd" },

    { "id": "249", "district_id": "33", "name": "Hasnabad Bazar", "bn_name": "বরিশাল সদর", "url": "barisalsadar.barisal.gov.bd" },
    { "id": "250", "district_id": "33", "name": "Lakkhanpur", "bn_name": "বাকেরগঞ্জ", "url": "bakerganj.barisal.gov.bd" },
    { "id": "251", "district_id": "33", "name": "Lalchandpur", "bn_name": "বাবুগঞ্জ", "url": "babuganj.barisal.gov.bd" },
    { "id": "252", "district_id": "33", "name": "Monohorganj Sadar", "bn_name": "উজিরপুর", "url": "wazirpur.barisal.gov.bd" },
    { "id": "253", "district_id": "33", "name": "Natherpetua", "bn_name": "বানারীপাড়া", "url": "banaripara.barisal.gov.bd" },
    { "id": "254", "district_id": "33", "name": "Shikchail", "bn_name": "গৌরনদী", "url": "gournadi.barisal.gov.bd" },

    { "id": "259", "district_id": "34", "name": "Muradnagar Bangra", "bn_name": "ভোলা সদর", "url": "sadar.bhola.gov.bd" },
    { "id": "260", "district_id": "34", "name": "Muradnagar Companyganj", "bn_name": "বোরহান উদ্দিন", "url": "borhanuddin.bhola.gov.bd" },
    { "id": "261", "district_id": "34", "name": "Muradnagar Muradnagar", "bn_name": "চরফ্যাশন", "url": "charfesson.bhola.gov.bd" },
    { "id": "262", "district_id": "34", "name": "Muradnagar Pantibazar", "bn_name": "দৌলতখান", "url": "doulatkhan.bhola.gov.bd" },
    { "id": "263", "district_id": "34", "name": "Muradnagar Ramchandarpur", "bn_name": "মনপুরা", "url": "monpura.bhola.gov.bd" },
    { "id": "264", "district_id": "34", "name": "Muradnagar Sonakanda", "bn_name": "তজুমদ্দিন", "url": "tazumuddin.bhola.gov.bd" },

    { "id": "266", "district_id": "35", "name": "Badurtola", "bn_name": "আমতলী", "url": "amtali.barguna.gov.bd" },
    { "id": "267", "district_id": "35", "name": "Baro Para", "bn_name": "বরগুনা সদর", "url": "sadar.barguna.gov.bd" },
    { "id": "268", "district_id": "35", "name": "Comilla Housing", "bn_name": "বেতাগী", "url": "betagi.barguna.gov.bd" },
    { "id": "269", "district_id": "35", "name": "Comilla Sadar Comilla Contonment", "bn_name": "বামনা", "url": "bamna.barguna.gov.bd" },
    { "id": "270", "district_id": "35", "name": "Comilla Sadar Courtbari", "bn_name": "পাথরঘাটা", "url": "pathorghata.barguna.gov.bd" },
    { "id": "271", "district_id": "35", "name": "Comilla Sadar Halimanagar", "bn_name": "তালতলি", "url": "taltali.barguna.gov.bd" },
    { "id": "271", "district_id": "35", "name": "Comilla Sadar Suaganj", "bn_name": "তালতলি", "url": "taltali.barguna.gov.bd" },
    { "id": "271", "district_id": "35", "name": "Dharmopur", "bn_name": "তালতলি", "url": "taltali.barguna.gov.bd" },
    { "id": "271", "district_id": "35", "name": "Kandirpar", "bn_name": "তালতলি", "url": "taltali.barguna.gov.bd" },
    { "id": "271", "district_id": "35", "name": "Kaptan Bazar", "bn_name": "তালতলি", "url": "taltali.barguna.gov.bd" },
    { "id": "271", "district_id": "35", "name": "Paduar Bazar", "bn_name": "তালতলি", "url": "taltali.barguna.gov.bd" },
    { "id": "271", "district_id": "35", "name": "Shashongachha", "bn_name": "তালতলি", "url": "taltali.barguna.gov.bd" },
    { "id": "271", "district_id": "35", "name": "Tomsom Bridge", "bn_name": "তালতলি", "url": "taltali.barguna.gov.bd" },


    { "id": "272", "district_id": "36", "name": "Baharchora", "bn_name": "বালাগঞ্জ", "url": "balaganj.sylhet.gov.bd" },
    { "id": "273", "district_id": "36", "name": "Bazarghata", "bn_name": "বিয়ানীবাজার", "url": "beanibazar.sylhet.gov.bd" },
    { "id": "274", "district_id": "36", "name": "Cox's Bazar Bus Terminal", "bn_name": "বিশ্বনাথ", "url": "bishwanath.sylhet.gov.bd" },
    { "id": "275", "district_id": "36", "name": "Holiday Mor", "bn_name": "কোম্পানীগঞ্জ", "url": "companiganj.sylhet.gov.bd" },
    { "id": "276", "district_id": "36", "name": "Kolatoli", "bn_name": "ফেঞ্চুগঞ্জ", "url": "fenchuganj.sylhet.gov.bd" },
    { "id": "277", "district_id": "36", "name": "Laldighi Par", "bn_name": "গোলাপগঞ্জ", "url": "golapganj.sylhet.gov.bd" },
    { "id": "278", "district_id": "36", "name": "Link Road", "bn_name": "গোয়াইনঘাট", "url": "gowainghat.sylhet.gov.bd" },


    { "id": "285", "district_id": "37", "name": "Eidgaon Union Parishad", "bn_name": "বড়লেখা", "url": "barlekha.moulvibazar.gov.bd" },
    { "id": "286", "district_id": "37", "name": "Pokkhali", "bn_name": "কমলগঞ্জ", "url": "kamolganj.moulvibazar.gov.bd" },



    { "id": "292", "district_id": "38", "name": "Badher Gora", "bn_name": "নবীগঞ্জ", "url": "nabiganj.habiganj.gov.bd" },
    { "id": "293", "district_id": "38", "name": "Bhuiyanr Hat", "bn_name": "বাহুবল", "url": "bahubal.habiganj.gov.bd" },
    { "id": "294", "district_id": "38", "name": "Char Hakdi", "bn_name": "আজমিরীগঞ্জ", "url": "ajmiriganj.habiganj.gov.bd" },
    { "id": "295", "district_id": "38", "name": "Char Laxigonj", "bn_name": "বানিয়াচং", "url": "baniachong.habiganj.gov.bd" },
    { "id": "296", "district_id": "38", "name": "Chowdhuri Hat", "bn_name": "লাখাই", "url": "lakhai.habiganj.gov.bd" },
    { "id": "297", "district_id": "38", "name": "Daganbhuiyan Chhilonia", "bn_name": "চুনারুঘাট", "url": "chunarughat.habiganj.gov.bd" },
    { "id": "298", "district_id": "38", "name": "Daganbhuiyan Dudmukha", "bn_name": "হবিগঞ্জ সদর", "url": "habiganjsadar.habiganj.gov.bd" },
    { "id": "299", "district_id": "38", "name": "Daganbhuiyan Rajapur", "bn_name": "মাধবপুর", "url": "madhabpur.habiganj.gov.bd" },
    { "id": "299", "district_id": "38", "name": "Daganbhuiyan Upazila Parishad", "bn_name": "মাধবপুর", "url": "madhabpur.habiganj.gov.bd" },
    { "id": "299", "district_id": "38", "name": "Khushipur", "bn_name": "মাধবপুর", "url": "madhabpur.habiganj.gov.bd" },
    { "id": "299", "district_id": "38", "name": "Mowlana Ghat Ferry Terminal", "bn_name": "মাধবপুর", "url": "madhabpur.habiganj.gov.bd" },
    { "id": "299", "district_id": "38", "name": "Purba Chandrapur", "bn_name": "মাধবপুর", "url": "madhabpur.habiganj.gov.bd" },
    { "id": "299", "district_id": "38", "name": "Sebar Hat", "bn_name": "মাধবপুর", "url": "madhabpur.habiganj.gov.bd" },
    { "id": "299", "district_id": "38", "name": "Sindurpur Bazar", "bn_name": "মাধবপুর", "url": "madhabpur.habiganj.gov.bd" },
    { "id": "299", "district_id": "38", "name": "South Karimpur Dagonbhuiyan Feni", "bn_name": "মাধবপুর", "url": "madhabpur.habiganj.gov.bd" },
    { "id": "299", "district_id": "38", "name": "South Neaz Pur", "bn_name": "মাধবপুর", "url": "madhabpur.habiganj.gov.bd" },
    { "id": "299", "district_id": "38", "name": "Taltoli Bazar", "bn_name": "মাধবপুর", "url": "madhabpur.habiganj.gov.bd" },


    { "id": "300", "district_id": "39", "name": "Diginala Sadar", "bn_name": "সুনামগঞ্জ সদর", "url": "sadar.sunamganj.gov.bd" },


    { "id": "311", "district_id": "40", "name": "Fatichhari Maiz Vandar Sharif", "bn_name": "বেলাবো", "url": "belabo.narsingdi.gov.bd" },
    { "id": "312", "district_id": "40", "name": "Fatikchhari Fatikchhari", "bn_name": "মনোহরদী", "url": "monohardi.narsingdi.gov.bd" },
    { "id": "313", "district_id": "40", "name": "Fatikchhari Harualchhari", "bn_name": "নরসিংদী সদর", "url": "narsingdisadar.narsingdi.gov.bd" },
    { "id": "314", "district_id": "40", "name": "Fatikchhari Najirhat", "bn_name": "পলাশ", "url": "palash.narsingdi.gov.bd" },
    { "id": "315", "district_id": "40", "name": "Fatikchhari Nanupur", "bn_name": "রায়পুরা", "url": "raipura.narsingdi.gov.bd" },
    { "id": "316", "district_id": "40", "name": "Fatikchhari Narayanhat", "bn_name": "শিবপুর", "url": "shibpur.narsingdi.gov.bd" },



    { "id": "317", "district_id": "41", "name": "Amtoli Bazar", "bn_name": "কালীগঞ্জ", "url": "kaliganj.gazipur.gov.bd" },
    { "id": "318", "district_id": "41", "name": "Bhanga Takia Bazar Sharshadie", "bn_name": "কালিয়াকৈর", "url": "kaliakair.gazipur.gov.bd" },
    { "id": "319", "district_id": "41", "name": "Biroli Bazar Bridge", "bn_name": "কাপাসিয়া", "url": "kapasia.gazipur.gov.bd" },
    { "id": "320", "district_id": "41", "name": "Court Buliding", "bn_name": "গাজীপুর সদর", "url": "sadar.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Daud Pul", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Dharmapur Amin Bazar", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Feni Cadet College", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Feni Circuit House", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Feni Police Line", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Feni Polytechnic Institute", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Feni Sadar", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Feni Sadar Fazilpur", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Feni Sadar Hospital", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Feni Sadar Laskarhat", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Feni Stadium", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Feni TB Hospital", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Feni University", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Grand Trunk Road", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Grand Trunk Road Squre", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Gunabati Railway Station", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Hazir Bazar Post OfficeSharshadie", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Ja Academy", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Kalidaha- Laskarhat Rd", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Khaiyara The Head", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Lalpul", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Laskarhat Post Office", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Laskar Hat S C Laha Institution", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Mastar Para", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Mohipal", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Panchgachia Bazar", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Parshuram Munsirhat", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Parshuram Peerboxhat", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Petro Bangla", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Pirganj Laldigi", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Rampur", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Ranir Hat", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Santi Company Road", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Shodeb Pur", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Shohid Selina Parvin Road", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Shuvapur", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Tewmuhuni Bazar", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },
    { "id": "321", "district_id": "41", "name": "Ukil Para", "bn_name": "শ্রীপুর", "url": "sreepur.gazipur.gov.bd" },



    { "id": "322", "district_id": "42", "name": "Hathazari Chitt.University", "bn_name": "শরিয়তপুর সদর", "url": "sadar.shariatpur.gov.bd" },
    { "id": "323", "district_id": "42", "name": "Hathazari Fatahabad", "bn_name": "নড়িয়া", "url": "naria.shariatpur.gov.bd" },
    { "id": "324", "district_id": "42", "name": "Hathazari Gorduara", "bn_name": "জাজিরা", "url": "zajira.shariatpur.gov.bd" },
    { "id": "325", "district_id": "42", "name": "Hathazari Hathazari", "bn_name": "গোসাইরহাট", "url": "gosairhat.shariatpur.gov.bd" },
    { "id": "326", "district_id": "42", "name": "Hathazari Katirhat", "bn_name": "ভেদরগঞ্জ", "url": "bhedarganj.shariatpur.gov.bd" },
    { "id": "327", "district_id": "42", "name": "Hathazari Madrasa", "bn_name": "ডামুড্যা", "url": "damudya.shariatpur.gov.bd" },
    { "id": "327", "district_id": "42", "name": "Hathazari Mirzapur", "bn_name": "ডামুড্যা", "url": "damudya.shariatpur.gov.bd" },
    { "id": "327", "district_id": "42", "name": "Hathazari Nuralibari", "bn_name": "ডামুড্যা", "url": "damudya.shariatpur.gov.bd" },
    { "id": "327", "district_id": "42", "name": "Hathazari Yunus Nagar", "bn_name": "ডামুড্যা", "url": "damudya.shariatpur.gov.bd" },




    { "id": "328", "district_id": "43", "name": "Hatiya Afazia", "bn_name": "আড়াইহাজার", "url": "araihazar.narayanganj.gov.bd" },
    { "id": "329", "district_id": "43", "name": "Hatiya Sadar", "bn_name": "বন্দর", "url": "bandar.narayanganj.gov.bd" },
    { "id": "330", "district_id": "43", "name": "Hatiya Tamoraddi", "bn_name": "নারায়নগঞ্জ সদর", "url": "narayanganjsadar.narayanganj.gov.bd" },


    { "id": "333", "district_id": "44", "name": "Jarachhari Jarachhari", "bn_name": "বাসাইল", "url": "basail.tangail.gov.bd" },



    { "id": "345", "district_id": "45", "name": "Kaptai Chandraghona", "bn_name": "ইটনা", "url": "itna.kishoreganj.gov.bd" },
    { "id": "346", "district_id": "45", "name": "Kaptai Kaptai Project", "bn_name": "কটিয়াদী", "url": "katiadi.kishoreganj.gov.bd" },
    { "id": "347", "district_id": "45", "name": "Kaptai Nuton Bazar", "bn_name": "ভৈরব", "url": "bhairab.kishoreganj.gov.bd" },
    { "id": "348", "district_id": "45", "name": "Kaptai Sadar", "bn_name": "তাড়াইল", "url": "tarail.kishoreganj.gov.bd" },


    { "id": "358", "district_id": "46", "name": "Betbunia", "bn_name": "হরিরামপুর", "url": "harirampur.manikganj.gov.bd" },
    { "id": "359", "district_id": "46", "name": "Kalampati", "bn_name": "সাটুরিয়া", "url": "saturia.manikganj.gov.bd" },


    { "id": "365", "district_id": "47", "name": "Alichan Para", "bn_name": "সাভার", "url": "savar.dhaka.gov.bd" },
    { "id": "366", "district_id": "47", "name": "Ananta Master Para", "bn_name": "ধামরাই", "url": "dhamrai.dhaka.gov.bd" },
    { "id": "367", "district_id": "47", "name": "Babuchhara", "bn_name": "কেরাণীগঞ্জ", "url": "keraniganj.dhaka.gov.bd" },
    { "id": "368", "district_id": "47", "name": "Baghaichari Mukh", "bn_name": "নবাবগঞ্জ", "url": "nawabganj.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Bara Panchhari", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Boalkhali Bazar", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Buddhist Monastery", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Chatrachhara Ch Mohan Para", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Chengy Square", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Dighinala", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Duluchhari", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Gyanangkur Buddha Vihara", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Islampur", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Jamtoli", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Jogesh Ch Karbari Para", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Kabakhali Bazar", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Khagrachari Sadar", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Komalchari Hadmanpara Bazar", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Kukichhara", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Lakshmichhari", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Logang", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Madhupur Bazar", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Madhya Dhanpatar", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Mahajanpara", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Mahalchhari", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Matiranga", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Narankhaya", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Nunchhari", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Panchhari", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Perachara", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Purbo Hasin Sanadpur", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Ramgarh", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Sardangchhara", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Shalbagan", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Shanirvar", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Taindang", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },
    { "id": "369", "district_id": "47", "name": "Thakurchara", "bn_name": "দোহার", "url": "dohar.dhaka.gov.bd" },



    { "id": "370", "district_id": "48", "name": "Manikchhari Sadar", "bn_name": "মুন্সিগঞ্জ সদর", "url": "sadar.munshiganj.gov.bd" },


    { "id": "376", "district_id": "49", "name": "Dhurung", "bn_name": "রাজবাড়ী সদর", "url": "sadar.rajbari.gov.bd" },
    { "id": "377", "district_id": "49", "name": "Kutubdia Sadar", "bn_name": "গোয়ালন্দ", "url": "goalanda.rajbari.gov.bd" },
    { "id": "378", "district_id": "49", "name": "Lemsikhali", "bn_name": "পাংশা", "url": "pangsa.rajbari.gov.bd" },


    { "id": "381", "district_id": "50", "name": "Birahimpur Lakshmipur", "bn_name": "মাদারীপুর সদর", "url": "sadar.madaripur.gov.bd" },
    { "id": "382", "district_id": "50", "name": "Charshai", "bn_name": "শিবচর", "url": "shibchar.madaripur.gov.bd" },
    { "id": "383", "district_id": "50", "name": "Jagannatpur", "bn_name": "কালকিনি", "url": "kalkini.madaripur.gov.bd" },
    { "id": "384", "district_id": "50", "name": "Lakshmipur Sadar", "bn_name": "রাজৈর", "url": "rajoir.madaripur.gov.bd" },
    { "id": "384", "district_id": "50", "name": "Lakshmipur Sadar Amani Lakshimpur", "bn_name": "রাজৈর", "url": "rajoir.madaripur.gov.bd" },
    { "id": "384", "district_id": "50", "name": "Lakshmipur Sadar Chandraganj", "bn_name": "রাজৈর", "url": "rajoir.madaripur.gov.bd" },
    { "id": "384", "district_id": "50", "name": "Lakshmipur Sadar Choupalli", "bn_name": "রাজৈর", "url": "rajoir.madaripur.gov.bd" },
    { "id": "384", "district_id": "50", "name": "Lakshmipur Sadar Dalal Bazar", "bn_name": "রাজৈর", "url": "rajoir.madaripur.gov.bd" },
    { "id": "384", "district_id": "50", "name": "Lakshmipur Sadar Duttapara", "bn_name": "রাজৈর", "url": "rajoir.madaripur.gov.bd" },
    { "id": "384", "district_id": "50", "name": "Lakshmipur Sadar Keramatganj", "bn_name": "রাজৈর", "url": "rajoir.madaripur.gov.bd" },
    { "id": "384", "district_id": "50", "name": "Lakshmipur Sadar Mandari", "bn_name": "রাজৈর", "url": "rajoir.madaripur.gov.bd" },
    { "id": "384", "district_id": "50", "name": "Lakshmipur Sadar Rupchara", "bn_name": "রাজৈর", "url": "rajoir.madaripur.gov.bd" },

    // ============================================


    { "id": "385", "district_id": "51", "name": "Keroa", "bn_name": "গোপালগঞ্জ সদর", "url": "sadar.gopalganj.gov.bd" },
    { "id": "386", "district_id": "51", "name": "Raipur Sadar", "bn_name": "কাশিয়ানী", "url": "kashiani.gopalganj.gov.bd" },

    { "id": "390", "district_id": "52", "name": "Ramganj Alipur", "bn_name": "ফরিদপুর সদর", "url": "sadar.faridpur.gov.bd" },
    { "id": "391", "district_id": "52", "name": "Ramganj Bazar", "bn_name": "আলফাডাঙ্গা", "url": "alfadanga.faridpur.gov.bd" },
    { "id": "392", "district_id": "52", "name": "Ramganj Dolta", "bn_name": "বোয়ালমারী", "url": "boalmari.faridpur.gov.bd" },
    { "id": "393", "district_id": "52", "name": "Ramganj Kanchanpur", "bn_name": "সদরপুর", "url": "sadarpur.faridpur.gov.bd" },
    { "id": "394", "district_id": "52", "name": "Ramganj Naagmud", "bn_name": "নগরকান্দা", "url": "nagarkanda.faridpur.gov.bd" },
    { "id": "395", "district_id": "52", "name": "Ramganj Panpara", "bn_name": "ভাঙ্গা", "url": "bhanga.faridpur.gov.bd" },


    { "id": "399", "district_id": "53", "name": "Char Alexander", "bn_name": "পঞ্চগড় সদর", "url": "panchagarhsadar.panchagarh.gov.bd" },
    { "id": "400", "district_id": "53", "name": "Char Alexgander Hajirghat", "bn_name": "দেবীগঞ্জ", "url": "debiganj.panchagarh.gov.bd" },
    { "id": "401", "district_id": "53", "name": "Char Goshai", "bn_name": "বোদা", "url": "boda.panchagarh.gov.bd" },
    { "id": "402", "district_id": "53", "name": "Char Poragacha", "bn_name": "আটোয়ারী", "url": "atwari.panchagarh.gov.bd" },
    { "id": "403", "district_id": "53", "name": "Char Wapda", "bn_name": "তেতুলিয়া", "url": "tetulia.panchagarh.gov.bd" },
    { "id": "403", "district_id": "53", "name": "Kamalnagar Jomidar Hat Bazar", "bn_name": "তেতুলিয়া", "url": "tetulia.panchagarh.gov.bd" },
    { "id": "403", "district_id": "53", "name": "Ramgoti Bazar", "bn_name": "তেতুলিয়া", "url": "tetulia.panchagarh.gov.bd" },


    { "id": "404", "district_id": "54", "name": "Gulshakhali", "bn_name": "নবাবগঞ্জ", "url": "nawabganj.dinajpur.gov.bd" },
    { "id": "405", "district_id": "54", "name": "Langadu Sadar", "bn_name": "বীরগঞ্জ", "url": "birganj.dinajpur.gov.bd" },


    { "id": "417", "district_id": "55", "name": "Laxmichhari Sadar", "bn_name": "লালমনিরহাট সদর", "url": "sadar.lalmonirhat.gov.bd" },


    { "id": "422", "district_id": "56", "name": "Lohagara Chunti", "bn_name": "সৈয়দপুর", "url": "syedpur.nilphamari.gov.bd" },
    { "id": "423", "district_id": "56", "name": "Lohagara Lohagara", "bn_name": "ডোমার", "url": "domar.nilphamari.gov.bd" },
    { "id": "424", "district_id": "56", "name": "Lohagara Padua", "bn_name": "ডিমলা", "url": "dimla.nilphamari.gov.bd" },


    { "id": "428", "district_id": "57", "name": "Baranala", "bn_name": "সাদুল্লাপুর", "url": "sadullapur.gaibandha.gov.bd" },
    { "id": "429", "district_id": "57", "name": "Matiranga Sadar", "bn_name": "গাইবান্ধা সদর", "url": "gaibandhasadar.gaibandha.gov.bd" },
    { "id": "430", "district_id": "57", "name": "Taindong", "bn_name": "পলাশবাড়ী", "url": "palashbari.gaibandha.gov.bd" },


    { "id": "435", "district_id": "58", "name": "Mirsharai Abutorab", "bn_name": "ঠাকুরগাঁও সদর", "url": "thakurgaonsadar.thakurgaon.gov.bd" },
    { "id": "436", "district_id": "58", "name": "Mirsharai Azampur", "bn_name": "পীরগঞ্জ", "url": "pirganj.thakurgaon.gov.bd" },
    { "id": "437", "district_id": "58", "name": "Mirsharai Bharawazhat", "bn_name": "রাণীশংকৈল", "url": "ranisankail.thakurgaon.gov.bd" },
    { "id": "438", "district_id": "58", "name": "Mirsharai Darrogahat", "bn_name": "হরিপুর", "url": "haripur.thakurgaon.gov.bd" },
    { "id": "439", "district_id": "58", "name": "Mirsharai Joarganj", "bn_name": "বালিয়াডাঙ্গী", "url": "baliadangi.thakurgaon.gov.bd" },
    { "id": "439", "district_id": "58", "name": "Mirsharai Korerhat", "bn_name": "বালিয়াডাঙ্গী", "url": "baliadangi.thakurgaon.gov.bd" },
    { "id": "439", "district_id": "58", "name": "Mirsharai Mirsharai", "bn_name": "বালিয়াডাঙ্গী", "url": "baliadangi.thakurgaon.gov.bd" },
    { "id": "439", "district_id": "58", "name": "Mirsharai Mohazanhat", "bn_name": "বালিয়াডাঙ্গী", "url": "baliadangi.thakurgaon.gov.bd" },


    { "id": "440", "district_id": "59", "name": "Gorakghat", "bn_name": "রংপুর সদর", "url": "rangpursadar.rangpur.gov.bd" },


    { "id": "448", "district_id": "60", "name": "Naniachhar Sadar", "bn_name": "কুড়িগ্রাম সদর", "url": "kurigramsadar.kurigram.gov.bd" },


    { "id": "457", "district_id": "61", "name": "Alayarpur", "bn_name": "শেরপুর সদর", "url": "sherpursadar.sherpur.gov.bd" },
    { "id": "458", "district_id": "61", "name": "Amishsha Para", "bn_name": "নালিতাবাড়ী", "url": "nalitabari.sherpur.gov.bd" },
    { "id": "459", "district_id": "61", "name": "Andar Char", "bn_name": "শ্রীবরদী", "url": "sreebordi.sherpur.gov.bd" },
    { "id": "460", "district_id": "61", "name": "Banglabazar", "bn_name": "নকলা", "url": "nokla.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Bangla Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Bashurhaat", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Binodpur", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Bishwanaath Bus Stop", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Bojra Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Boro Mosjid Mor", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Chaiyaani Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Chandraganj Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Char Elahi Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Char Jabbar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Char Jublee", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Chatarpaiyaa", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Chatarpaiya Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Chatkil", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Chowmohani Chowrasta", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Church Of The Queen Of Lourdes", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Companiganj Noakhali", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Dotter Haat", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Ekhlashpur Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Eklashpur Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Gabua Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Gazirhat Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Harinarayanpur Railway Station", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Hatiya Upazila Parishad", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Housing State", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Islamganj Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Islamgonz Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Jomidar Haat", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Joyaag Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Kabirhaat", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Kalitera Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Kalyandi Post Office", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Kankirhaat", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Kashem Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Khalifar Hat Post Office", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Khaser Hat", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Kormulla Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Maijdee Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Mannan Nagar Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Master Para", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Medical Assistant Training School,Noakhali", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Mir Warishpur", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Mohila College Morr", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Molongchor Poler Gora", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Musapur Union Parishad", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Bangla Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Circuit House", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Government College", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Pouro Bazaar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Puraton College", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Sadar Chaprashir Hat", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Sadar Charam Tua", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Sadar Char Jabbar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Sadar Din Monir Hat", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Sadar Kabirhat", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Sadar Khalifar Hat", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Sadar Mriddarhat", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Sadar Pak Kishoreganj", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Super Market", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Tv Center", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Noakhali Upazila Parishad", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Nowarhat Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "NSTU", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Rajganj Post Office", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Ramjan Bibi", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Ramzanbibi Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Rongmala", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Sebarhat Bazaar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Senbag", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Shaheber Haat", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Shetu Bhanga Bazaar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Shubornochar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Sonaimuri", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Sonapur Bus Stand", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Subarnachar Upazila Parishad", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Textile College", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Thekar Hat Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Totar Bazar", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Townhall Mor", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },
    { "id": "461", "district_id": "61", "name": "Trighoria", "bn_name": "ঝিনাইগাতী", "url": "jhenaigati.sherpur.gov.bd" },

    { "id": "462", "district_id": "62", "name": "Panchhari Sadar", "bn_name": "ফুলবাড়ীয়া", "url": "fulbaria.mymensingh.gov.bd" },

    { "id": "475", "district_id": "63", "name": "Pashurampur Fulgazi", "bn_name": "জামালপুর সদর", "url": "jamalpursadar.jamalpur.gov.bd" },
    { "id": "476", "district_id": "63", "name": "Pashurampur Munshirhat", "bn_name": "মেলান্দহ", "url": "melandah.jamalpur.gov.bd" },
    { "id": "477", "district_id": "63", "name": "Pashurampur Pashurampur", "bn_name": "ইসলামপুর", "url": "islampur.jamalpur.gov.bd" },
    { "id": "478", "district_id": "63", "name": "Pashurampur Shuarbazar", "bn_name": "দেওয়ানগঞ্জ", "url": "dewangonj.jamalpur.gov.bd" },



    { "id": "482", "district_id": "64", "name": "Patiya Budhpara", "bn_name": "বারহাট্টা", "url": "barhatta.netrokona.gov.bd" },
    { "id": "483", "district_id": "64", "name": "Patiya Sadar", "bn_name": "দুর্গাপুর", "url": "durgapur.netrokona.gov.bd" },


    { "id": "483", "district_id": "65", "name": "Rajsthali Sadar", "bn_name": "" },


    { "id": "483", "district_id": "66", "name": "Pathachhara", "bn_name": "" },
    { "id": "483", "district_id": "66", "name": "Ramghar Head Office", "bn_name": "" },


    { "id": "483", "district_id": "67", "name": "Ramu Sadar", "bn_name": "" },
    { "id": "483", "district_id": "67", "name": "Sonaichari", "bn_name": "" },

    { "id": "483", "district_id": "68", "name": "Barkal Bazar", "bn_name": "" },
    { "id": "483", "district_id": "68", "name": "Barkal Sadar", "bn_name": "" },
    { "id": "483", "district_id": "68", "name": "Panchagram", "bn_name": "" },


    { "id": "483", "district_id": "69", "name": "Marishya Sadar", "bn_name": "" },


    { "id": "483", "district_id": "70", "name": "Kathaltoli", "bn_name": "" },
    { "id": "483", "district_id": "70", "name": "Manikchari Rangamati", "bn_name": "" },
    { "id": "483", "district_id": "70", "name": "Rangamati Sadar", "bn_name": "" },
    { "id": "483", "district_id": "70", "name": "Vedvedi", "bn_name": "" },



    { "id": "483", "district_id": "71", "name": "Dakkhin Ghatchak", "bn_name": "" },
    { "id": "483", "district_id": "71", "name": "Fakirkill", "bn_name": "" },
    { "id": "483", "district_id": "71", "name": "Kadeer Nagar", "bn_name": "" },
    { "id": "483", "district_id": "71", "name": "Murad Nagar", "bn_name": "" },
    { "id": "483", "district_id": "71", "name": "Rangunia Dhamair", "bn_name": "" },
    { "id": "483", "district_id": "71", "name": "Rangunia Sadar", "bn_name": "" },
    { "id": "483", "district_id": "71", "name": "Sayad Bari", "bn_name": "" },
    { "id": "483", "district_id": "71", "name": "Uttar Gatchak", "bn_name": "" },



    { "id": "483", "district_id": "72", "name": "Raozan B.I.T Post Office", "bn_name": "" },
    { "id": "483", "district_id": "72", "name": "Raozan Beenajuri", "bn_name": "" },
    { "id": "483", "district_id": "72", "name": "Raozan Dewanpur", "bn_name": "" },
    { "id": "483", "district_id": "72", "name": "Raozan Fatepur", "bn_name": "" },
    { "id": "483", "district_id": "72", "name": "Raozan Guzra Noapara", "bn_name": "" },
    { "id": "483", "district_id": "72", "name": "Raozan jagannath Hat", "bn_name": "" },
    { "id": "483", "district_id": "72", "name": "Raozan Kundeshwari", "bn_name": "" },
    { "id": "483", "district_id": "72", "name": "Raozan Mohamuni", "bn_name": "" },
    { "id": "483", "district_id": "72", "name": "Raozan Pouroshobha", "bn_name": "" },
    { "id": "483", "district_id": "72", "name": "Rauzan Gahira", "bn_name": "" },



    { "id": "483", "district_id": "73", "name": "Raypur Bhuabari", "bn_name": "" },
    { "id": "483", "district_id": "73", "name": "Raypur Haydarganj", "bn_name": "" },
    { "id": "483", "district_id": "73", "name": "Raypur Khaser Hat", "bn_name": "" },
    { "id": "483", "district_id": "73", "name": "Raypur Nagerdighirpar", "bn_name": "" },
    { "id": "483", "district_id": "73", "name": "Raypur Rakhallia", "bn_name": "" },
    { "id": "483", "district_id": "73", "name": "Raypur Sadar", "bn_name": "" },





    { "id": "483", "district_id": "74", "name": "Sandwip Post Office", "bn_name": "" },
    { "id": "483", "district_id": "74", "name": "Sandwip Shiberhat", "bn_name": "" },
    { "id": "483", "district_id": "74", "name": "Sandwip Urirchar", "bn_name": "" },




    { "id": "483", "district_id": "75", "name": "Satkania Baitul Ijjat", "bn_name": "" },
    { "id": "483", "district_id": "75", "name": "Satkania Bazalia", "bn_name": "" },
    { "id": "483", "district_id": "75", "name": "Satkania Satkania", "bn_name": "" },




    { "id": "483", "district_id": "76", "name": "Senbag Beezbag", "bn_name": "" },
    { "id": "483", "district_id": "76", "name": "Senbag Chatarpaia", "bn_name": "" },
    { "id": "483", "district_id": "76", "name": "Senbag Kallyandi", "bn_name": "" },
    { "id": "483", "district_id": "76", "name": "Senbag Kankirhat", "bn_name": "" },
    { "id": "483", "district_id": "76", "name": "Senbag Sadar", "bn_name": "" },
    { "id": "483", "district_id": "76", "name": "Senbag T.P. Lamua", "bn_name": "" },



    { "id": "483", "district_id": "77", "name": "Shahrasti Chotoshi", "bn_name": "" },
    { "id": "483", "district_id": "77", "name": "Shahrasti Islamia Madrasha", "bn_name": "" },
    { "id": "483", "district_id": "77", "name": "Shahrasti Khilabazar", "bn_name": "" },
    { "id": "483", "district_id": "77", "name": "Shahrasti Pashchim Kherihar Al", "bn_name": "" },
    { "id": "483", "district_id": "77", "name": "Shahrasti Sadar", "bn_name": "" },



    { "id": "483", "district_id": "78", "name": "Sitakunda Barabkunda", "bn_name": "" },
    { "id": "483", "district_id": "78", "name": "Sitakunda Baroidhala", "bn_name": "" },
    { "id": "483", "district_id": "78", "name": "Sitakunda Bawashbaria", "bn_name": "" },
    { "id": "483", "district_id": "78", "name": "Sitakunda Bhatiari", "bn_name": "" },
    { "id": "483", "district_id": "78", "name": "Sitakunda Fouzdarhat", "bn_name": "" },
    { "id": "483", "district_id": "78", "name": "Sitakunda Jafrabad", "bn_name": "" },
    { "id": "483", "district_id": "78", "name": "Sitakunda Kumira", "bn_name": "" },
    { "id": "483", "district_id": "78", "name": "Sitakunda Sitakunda", "bn_name": "" },


    { "id": "483", "district_id": "79", "name": "Bakter Munshi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Bara Ahmadpur", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Char Laxmiganj", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Miyar Bazar Post Office Maruar Char", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Motiganj", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Nababpur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Nobi Ullah Bazar", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Olama Bazar", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Sombaria Bazar", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Sonagazi Ahmadpur", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Sonagazi Kazirhat", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Sonagazi Motiganj", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Sonagazi Sadar", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Sonagazi Upazila Office", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Sonapur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Sulakhali", "bn_name": "" },
    { "id": "483", "district_id": "79", "name": "Sundarpur Baligaon", "bn_name": "" },




    { "id": "483", "district_id": "80", "name": "Teknaf Hnila", "bn_name": "" },
    { "id": "483", "district_id": "80", "name": "Teknaf Sadar", "bn_name": "" },
    { "id": "483", "district_id": "80", "name": "Teknaf St.Martin", "bn_name": "" },


    { "id": "483", "district_id": "81", "name": "Ukhia - Noapara", "bn_name": "" },
    { "id": "483", "district_id": "81", "name": "Ukhia Sadar", "bn_name": "" },


    // ============================


    { "id": "483", "district_id": "82", "name": "Adamdighi", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Bagura Cantonment", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Bagura Sadar", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Balkuchi", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Balukapara", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Barachapra", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Bottola Bazar", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Chalapara", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Champapur", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Chandaikona", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Chandan Baisha", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Chhantiagram", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Debkhanda", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Dhunat", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Dupchachia", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Erulia", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Gabtoli", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Gokul", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Gosaibari", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Goshaibari", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Kahaloo", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Kahalu", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Khanpur", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Koyel", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Kundagram", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Kutubpur", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Lahiri Para", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Namuja", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Nandigram", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Nasharatpur", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Nasratpur", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Noongola", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Palli Unnyan Accademy", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Santahar", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Santahar Pouroshova", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Sariakandi", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Shabgram", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Shalikha", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Shekharkola", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Sherpur", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Sherpur Chakatola Road", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Shibganj", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Sonatola", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Sukhanpukur", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Talora", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Ulipurpara", "bn_name": "" },
    { "id": "483", "district_id": "82", "name": "Utra", "bn_name": "" },



    { "id": "483", "district_id": "83", "name": "Amnura", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Bholahat", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Chapai Nawabganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Char Bagdanga", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Debinagar", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Gobratola", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Gomashtapur", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Kansart", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Manaksha", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Mandumala", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Moharajpur", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Nachol", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Rajarampur", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Ramchandrapur", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Rohanpur", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Shahibag", "bn_name": "" },
    { "id": "483", "district_id": "83", "name": "Shibganj U.P.O", "bn_name": "" },



    { "id": "483", "district_id": "84", "name": "Akklepur", "bn_name": "" },
    { "id": "483", "district_id": "84", "name": "Amdai", "bn_name": "" },
    { "id": "483", "district_id": "84", "name": "Bhadsha Union", "bn_name": "" },
    { "id": "483", "district_id": "84", "name": "Dhalahar", "bn_name": "" },
    { "id": "483", "district_id": "84", "name": "Jamalganj Bazar", "bn_name": "" },
    { "id": "483", "district_id": "84", "name": "Joypurhat Municipality Office", "bn_name": "" },
    { "id": "483", "district_id": "84", "name": "Joypurhat Sadar", "bn_name": "" },
    { "id": "483", "district_id": "84", "name": "Joypurhat Stadium", "bn_name": "" },
    { "id": "483", "district_id": "84", "name": "Kalai", "bn_name": "" },
    { "id": "483", "district_id": "84", "name": "Khetlal", "bn_name": "" },
    { "id": "483", "district_id": "84", "name": "Mongolbari", "bn_name": "" },
    { "id": "483", "district_id": "84", "name": "Panchbibi", "bn_name": "" },
    { "id": "483", "district_id": "84", "name": "Puranapail", "bn_name": "" },
    { "id": "483", "district_id": "84", "name": "Tilakpur", "bn_name": "" },



    { "id": "483", "district_id": "85", "name": "Ahsanganj", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Badalgachhi", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Balihar", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Baludanga", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Bandai", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Dhamuirhat", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Dubalhati", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Hashaighari", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Kashimpur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Mahadevpur", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Manda", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Moduhil", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Naogaon Sadar", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Niamatpur", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Nitpur", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Panguria", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Patnitala", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Porsa", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Prasadpur", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Raninagar", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Sailgachhi", "bn_name": "" },
    { "id": "483", "district_id": "85", "name": "Sapahar", "bn_name": "" },




    { "id": "483", "district_id": "86", "name": "Abdulpur", "bn_name": "" },
    { "id": "483", "district_id": "86", "name": "Baiddyabal Gharia", "bn_name": "" },
    { "id": "483", "district_id": "86", "name": "Baraigram", "bn_name": "" },
    { "id": "483", "district_id": "86", "name": "Dattapara Bazar", "bn_name": "" },
    { "id": "483", "district_id": "86", "name": "Dayarampur", "bn_name": "" },
    { "id": "483", "district_id": "86", "name": "Digapatia", "bn_name": "" },
    { "id": "483", "district_id": "86", "name": "Gopalpur U.P.O", "bn_name": "" },
    { "id": "483", "district_id": "86", "name": "Harua", "bn_name": "" },
    { "id": "483", "district_id": "86", "name": "Hatgurudaspur", "bn_name": "" },
    { "id": "483", "district_id": "86", "name": "Lalpur S.O", "bn_name": "" },
    { "id": "483", "district_id": "86", "name": "Laxman", "bn_name": "" },
    { "id": "483", "district_id": "86", "name": "Madhnagar", "bn_name": "" },
    { "id": "483", "district_id": "86", "name": "Natore Sadar", "bn_name": "" },
    { "id": "483", "district_id": "86", "name": "Singra", "bn_name": "" },


    { "id": "483", "district_id": "87", "name": "Banwarinagar", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Bera", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Bhangura", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Chatmohar", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Dashuria", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Debottar", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Dhapari", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Hamayetpur", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Ishwardi", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Kaliko Cotton Mills", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Kashinathpur", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Nakalia", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Pabna Sadar", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Pakshi", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Puran Bharenga", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Rajapur Bus Station", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Ruppur", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Sagarkandi", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Sathia", "bn_name": "" },
    { "id": "483", "district_id": "87", "name": "Sujanagar", "bn_name": "" },



    { "id": "483", "district_id": "88", "name": "Arani", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Bagha", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Bhabaniganj", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Bhatkandi", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Binodpur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Charghat", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Durgapur", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Ghoramara", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Godagari", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Katakhali", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Kazla", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Khodmohanpur", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Lalitganj", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Nowhata", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Premtoli", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Putia", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Rajshahi Cantonment", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Rajshahi Court", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Rajshahi Sadar", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Rajshahi Sugar Mills", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Rajshahi University", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Sapura", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Sardah", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Shyampur", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Taherpur", "bn_name": "" },
    { "id": "483", "district_id": "88", "name": "Tanor", "bn_name": "" },



    { "id": "483", "district_id": "89", "name": "Baiddya Jam Toil", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Belkuchi", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Dhangora", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Enayetpur", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Gandail", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Jamirta", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Kaijuri", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Kazipur", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Lahiri Mohanpur", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Makimpur", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Malonga", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Porjana", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Raipur Station Playground", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Rashidabad", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Salap", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Shahjadpur", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Shuvgachha", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Sirajganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Sohagpur", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Sthal", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Tarash", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Ullapara", "bn_name": "" },
    { "id": "483", "district_id": "89", "name": "Ullapara R.S", "bn_name": "" },


    { "id": "483", "district_id": "90", "name": "Bagerhat Feri Ghat", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Bagerhat Launch Terminal", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Bagerhat Sadar", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Barabaria", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Bhanganpar Bazar", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Chalna Ankorage", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Charkulia", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Chitalmari", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Dariala", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Fakirhat", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Foylahat", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Gourambha", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Kachua", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Kahalpur", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Khardwar", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Mansa", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Mollahat", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Mongla Port", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Moniganj", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Morrelganj", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Nagarkandi", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "P.C College", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Pak Gangni", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Rampal", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Rayenda", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Sannasi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Satgombuj", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Sonarkola", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Sonatunia", "bn_name": "" },
    { "id": "483", "district_id": "90", "name": "Telisatee", "bn_name": "" },


    { "id": "483", "district_id": "91", "name": "Alamdanga", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Alukdia", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Andulbaria", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Chuadanga Boalmari", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Chuadanga P.T.I", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Chuadanga Sadar", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Damurhuda", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Darshana", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Dingedah", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Doulatganj", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Doulotdiar", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Gaid Ghat", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Hardi", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Hatikata Mor", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Hat Kalugonj", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Hazrahati", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Hoidarpur", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Joforpur", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Mominpur", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Munshiganj", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Nilmoniganj", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Nur Nagar", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Sath Gari Mor", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Sorojganj", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Subdia", "bn_name": "" },
    { "id": "483", "district_id": "91", "name": "Valaipur", "bn_name": "" },



    { "id": "483", "district_id": "92", "name": "Abhaynagar", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Bagachra", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Bagherpara", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Basundia", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Benapole", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Bhugilhat", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Chanchra", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Chougachha", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Churamankathi", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Gouranagar", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Jadabpur", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Jashore Airbach", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Jashore Cantonment", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Jashore - Noapara", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Jashore Sadar", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Jashore Upa - Shahar", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Jeshore Rajarhat", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Jhikargachha", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Keshobpur", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Monirampur", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Rupdia", "bn_name": "" },
    { "id": "483", "district_id": "92", "name": "Sarsa", "bn_name": "" },




    { "id": "483", "district_id": "93", "name": "Dobila", "bn_name": "" },
    { "id": "483", "district_id": "93", "name": "Ektarpur", "bn_name": "" },
    { "id": "483", "district_id": "93", "name": "Harinakundu", "bn_name": "" },
    { "id": "483", "district_id": "93", "name": "Hat gopalpur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "93", "name": "Jakaria", "bn_name": "" },
    { "id": "483", "district_id": "93", "name": "Jhenaidah Cadet College", "bn_name": "" },
    { "id": "483", "district_id": "93", "name": "Jhenaidah-Kaliganj", "bn_name": "" },
    { "id": "483", "district_id": "93", "name": "Jhenaidah Sadar", "bn_name": "" },
    { "id": "483", "district_id": "93", "name": "Kangshee", "bn_name": "" },
    { "id": "483", "district_id": "93", "name": "Kotchandpur", "bn_name": "" },
    { "id": "483", "district_id": "93", "name": "Maheshpur", "bn_name": "" },
    { "id": "483", "district_id": "93", "name": "Mayadhorpur Village", "bn_name": "" },
    { "id": "483", "district_id": "93", "name": "Naldanga", "bn_name": "" },
    { "id": "483", "district_id": "93", "name": "Shailakupa", "bn_name": "" },



    { "id": "483", "district_id": "94", "name": "Alaipur Sadar", "bn_name": "" },
    { "id": "483", "district_id": "94", "name": "Belphulia", "bn_name": "" },
    { "id": "483", "district_id": "94", "name": "Rupsha", "bn_name": "" },


    { "id": "483", "district_id": "95", "name": "Amadee Sadar", "bn_name": "" },

    { "id": "483", "district_id": "96", "name": "Batiaghat Sadar", "bn_name": "" },
    { "id": "483", "district_id": "96", "name": "Surkalee", "bn_name": "" },



    { "id": "483", "district_id": "97", "name": "Bajua", "bn_name": "" },
    { "id": "483", "district_id": "97", "name": "Chalna Bazar Sadar", "bn_name": "" },
    { "id": "483", "district_id": "97", "name": "Dakup", "bn_name": "" },
    { "id": "483", "district_id": "97", "name": "Nalian", "bn_name": "" },


    { "id": "483", "district_id": "98", "name": "Chandni Mahal", "bn_name": "" },
    { "id": "483", "district_id": "98", "name": "Digalia Sadar", "bn_name": "" },
    { "id": "483", "district_id": "98", "name": "Gazirhat", "bn_name": "" },
    { "id": "483", "district_id": "98", "name": "Ghoshghati", "bn_name": "" },
    { "id": "483", "district_id": "98", "name": "Senhati", "bn_name": "" },


    { "id": "483", "district_id": "196", "name": "Chuknagar", "bn_name": "" },
    { "id": "483", "district_id": "196", "name": "Magurkhali", "bn_name": "" },
    { "id": "483", "district_id": "196", "name": "Shahpur", "bn_name": "" },
    { "id": "483", "district_id": "196", "name": "Sorafpur", "bn_name": "" },


    { "id": "483", "district_id": "99", "name": "Kapilmoni", "bn_name": "" },
    { "id": "483", "district_id": "99", "name": "Paikgachha Sadar", "bn_name": "" },


    { "id": "483", "district_id": "100", "name": "Ajogora", "bn_name": "" },
    { "id": "483", "district_id": "100", "name": "Barasat", "bn_name": "" },
    { "id": "483", "district_id": "100", "name": "Terokhada Sadar", "bn_name": "" },



    { "id": "483", "district_id": "101", "name": "Atra Shilpa Area", "bn_name": "" },
    { "id": "483", "district_id": "101", "name": "BIT Khulna", "bn_name": "" },
    { "id": "483", "district_id": "101", "name": "Doulatpur", "bn_name": "" },
    { "id": "483", "district_id": "101", "name": "Jahanabad Cantonment", "bn_name": "" },
    { "id": "483", "district_id": "101", "name": "Khulna G.P.O", "bn_name": "" },
    { "id": "483", "district_id": "101", "name": "Khulna Sadar", "bn_name": "" },
    { "id": "483", "district_id": "101", "name": "Khulna Shipyard", "bn_name": "" },
    { "id": "483", "district_id": "101", "name": "Khulna University", "bn_name": "" },
    { "id": "483", "district_id": "101", "name": "Siramani", "bn_name": "" },
    { "id": "483", "district_id": "101", "name": "Sonali Jute Mills", "bn_name": "" },





    { "id": "483", "district_id": "102", "name": "Bheramara Bazar", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Boro Bazer", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "BRB Bscic Area", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Chorhas", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Housing", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Islamic University - Kushtia", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Khas mathurapur", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Khoksa", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Kumarkhali", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Kumarkhali Bazar", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Kushtia Mohini", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Kushtia Sadar", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Lahini Bot Toil", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Mirpur", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Mojompur", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Mongolbari Bazar", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Poradaho Bazer", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Singer Mor", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Taragunia", "bn_name": "" },
    { "id": "483", "district_id": "102", "name": "Tri-Mohoni Bazar", "bn_name": "" },


    { "id": "483", "district_id": "103", "name": "Magura Sadar", "bn_name": "" },
    { "id": "483", "district_id": "103", "name": "Mohammadpur", "bn_name": "" },
    { "id": "483", "district_id": "103", "name": "Shalikha Upazila", "bn_name": "" },
    { "id": "483", "district_id": "103", "name": "Sreepur Road", "bn_name": "" },


    { "id": "483", "district_id": "104", "name": "Amjhupi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Bajitpur Border", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Bamun Para", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Baribaka", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Boro Bazar", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Bosepara", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Buripota Border", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Chadbil Mor", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Gangni Bamundi", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Gangni Dhankhola", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Gangni Harbhanga", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Gangni Kasba", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Gangni Kumaridanga", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Gangni Manikdia", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Gangni Nittyanandapur", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Gangni Sadar", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Gopalpur", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Khan Para", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Kolar Mor", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Kulbaria Bazar", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Meherpur Bandar", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Meherpur Bus Stand Para", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Meherpur College Mor", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Meherpur Ghosh Para", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Meherpur Hospital Gate", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Meherpur Hotel Bazar", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Meherpur Jailkhana Para", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Meherpur Mollick Para", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Meherpur Post Office", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Meherpur Sadar", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Meherpur Stadium Para", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Meherpur Wapda Mor", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Mujib Nagar Complex", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Mujibnagar Dariapur", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Mujibnagar Gopalpur", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Mujibnagar Gourinagar Haat", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Mujibnagar Mohajanpur", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Mujibnagar Monakhali", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Mujibnagar Roshikpur", "bn_name": "" },
    { "id": "483", "district_id": "104", "name": "Ujolpur", "bn_name": "" },


    { "id": "483", "district_id": "105", "name": "Adompur", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Aladatpur", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Awuriya", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Badha Ghat Mor", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Balarampur", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Baradia", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Bashgram Bazar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Bharashula", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Bhawakhali", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Bishnupur", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Bolorampur", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Chamroli", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Circuit House Area", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Dokkhin Narail", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Doljitpur", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Dumurtola", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Durvazury", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Ghorakhali Bazar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Ghorakhali Mor", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Gobra Bazar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Gochar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Gourinagar Haat", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Habakhali", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Harigara Bajar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Hatbariya", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Hobokhali", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Itna", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Jogia", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Jurulia", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Kalia", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Kalia Bagdanga Narail", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Kalia Ballahati", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Kalia Bazar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Kalia Benda", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Kalia Chhota Kalia Part", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Kalia Chorkhali", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Kalia Piroli", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Kalia Polbazzar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Kalia Purulia", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Kalia Tona", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Laxmipasha", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Lohagara Amada", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Lohagara Bazar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Lohagara Dighalia", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Lohagara Gobornada", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Lohagara Kamthana", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Lohagara Manikgonj Bazar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Lohagara Naldi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Lohagara Noagram", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Lohagara Nowapara", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Lohagora", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Loskorpur", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Maijpara Bazar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Maizpara", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Mithapur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Mohish Khola", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Mohiskhola", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Mulia", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Naldi", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Naragati Gouripur Bazar Narail", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Naragati Kalabaria Boaliarcharpara", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Narail Batenga", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Narail Chowrasta", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Narail City College Mor", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Narail DC Office Mor", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Narail Durgapur", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Narail Gabtola", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Narail Kurigram", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Narail Madrasa Bazar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Narail Puratan Terminal Area", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Narail Puraton Bridge", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Narail Rupganj Bazar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Narail Sadar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Narail Sitarampur", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Narail Terminal", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Nayanpur", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Nirali", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Nishinath Tola", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Ronda Purba Para", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Rotodanga", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Rupgonj Bazar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Shahabad", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Singia", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Sitarampur", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "S M Sultan Memorial Area", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Sm Sultan Mor", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Sorospur", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "South Narail", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Subdhi Danga", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Tularampur", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Tularampur Bajar", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Vaduli Danga", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Vatiya", "bn_name": "" },
    { "id": "483", "district_id": "105", "name": "Vorasula", "bn_name": "" },





    { "id": "483", "district_id": "106", "name": "Assasuni", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Baikari Union", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Bhomra Union", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Budhhat", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Buri Goalini", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Chanduria", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Debhata", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Dhulihar", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Gabura", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Ghona", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Jhaudanga", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Kalaroa", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Kuskhali", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Nalta Mubaroknagar", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Noornagar", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Patkelghata", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Ratanpur", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Satkhira Islamia Acc", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Satkhira Kaliganj", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Satkhira Sadar", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Shyamnagar", "bn_name": "" },
    { "id": "483", "district_id": "106", "name": "Taala", "bn_name": "" },



    // ==========================================

    { "id": "483", "district_id": "107", "name": "Amtali", "bn_name": "" },
    { "id": "483", "district_id": "107", "name": "Bamna", "bn_name": "" },
    { "id": "483", "district_id": "107", "name": "Barguna Government College", "bn_name": "" },
    { "id": "483", "district_id": "107", "name": "Barguna Sadar", "bn_name": "" },
    { "id": "483", "district_id": "107", "name": "Barguna Taltali", "bn_name": "" },
    { "id": "483", "district_id": "107", "name": "Barguna West Police Farry", "bn_name": "" },
    { "id": "483", "district_id": "107", "name": "Betagi", "bn_name": "" },
    { "id": "483", "district_id": "107", "name": "Darul Ulum", "bn_name": "" },
    { "id": "483", "district_id": "107", "name": "Kakchira", "bn_name": "" },
    { "id": "483", "district_id": "107", "name": "Nali Bandar", "bn_name": "" },
    { "id": "483", "district_id": "107", "name": "Patharghata", "bn_name": "" },


    { "id": "483", "district_id": "108", "name": "Agailjhara Bazar", "bn_name": "" },
    { "id": "483", "district_id": "108", "name": "Agailjhara Sadar", "bn_name": "" },
    { "id": "483", "district_id": "108", "name": "Gaila", "bn_name": "" },
    { "id": "483", "district_id": "108", "name": "Paisarhat", "bn_name": "" },


    { "id": "483", "district_id": "109", "name": "Babuganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "109", "name": "Barishal Cadet College", "bn_name": "" },
    { "id": "483", "district_id": "109", "name": "Chandpasha", "bn_name": "" },
    { "id": "483", "district_id": "109", "name": "Dehergoti", "bn_name": "" },
    { "id": "483", "district_id": "109", "name": "Guthia", "bn_name": "" },
    { "id": "483", "district_id": "109", "name": "Madhabpasha", "bn_name": "" },
    { "id": "483", "district_id": "109", "name": "Nizamuddin College", "bn_name": "" },
    { "id": "483", "district_id": "109", "name": "Rahamatpur", "bn_name": "" },
    { "id": "483", "district_id": "109", "name": "Thakur Mallik", "bn_name": "" },



    { "id": "483", "district_id": "110", "name": "Bakerganj Darial", "bn_name": "" },
    { "id": "483", "district_id": "110", "name": "Charamandi", "bn_name": "" },
    { "id": "483", "district_id": "110", "name": "Garuria", "bn_name": "" },
    { "id": "483", "district_id": "110", "name": "Kalaskati", "bn_name": "" },
    { "id": "483", "district_id": "110", "name": "Padri Shibpur", "bn_name": "" },
    { "id": "483", "district_id": "110", "name": "Sahebganj", "bn_name": "" },


    { "id": "483", "district_id": "111", "name": "Batajor", "bn_name": "" },
    { "id": "483", "district_id": "111", "name": "Gouranadi Launch Ghat", "bn_name": "" },
    { "id": "483", "district_id": "111", "name": "Gouranadi Sadar", "bn_name": "" },
    { "id": "483", "district_id": "111", "name": "Kashemabad", "bn_name": "" },
    { "id": "483", "district_id": "111", "name": "Mridha market", "bn_name": "" },
    { "id": "483", "district_id": "111", "name": "Tarki Bandar", "bn_name": "" },



    { "id": "483", "district_id": "112", "name": "Barajalia Sadar", "bn_name": "" },
    { "id": "483", "district_id": "112", "name": "Memania", "bn_name": "" },
    { "id": "483", "district_id": "112", "name": "Osman Manjil", "bn_name": "" },



    { "id": "483", "district_id": "113", "name": "Langutia", "bn_name": "" },
    { "id": "483", "district_id": "113", "name": "Laskarpur", "bn_name": "" },
    { "id": "483", "district_id": "113", "name": "Mehendiganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "113", "name": "Ulania", "bn_name": "" },



    { "id": "483", "district_id": "114", "name": "Bara Madhab rayer char", "bn_name": "" },
    { "id": "483", "district_id": "114", "name": "Charkalekhan", "bn_name": "" },
    { "id": "483", "district_id": "114", "name": "Kazirchar", "bn_name": "" },
    { "id": "483", "district_id": "114", "name": "Muladi Sadar", "bn_name": "" },


    { "id": "483", "district_id": "115", "name": "Barishal Kazipara", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Barishal Sadar", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Bibir Pukur", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Bukhainagar", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Chahutpur", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Jaguarhat", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Kashipur", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Kawnia", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Moth Baria", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Natun Bazar", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Patang", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Rajmahal", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Rupatali", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Sadar Upazila", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Saheberhat", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Sugandia", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Taltali", "bn_name": "" },
    { "id": "483", "district_id": "115", "name": "Tia Khali", "bn_name": "" },


    { "id": "483", "district_id": "116", "name": "Dakuarhat", "bn_name": "" },
    { "id": "483", "district_id": "116", "name": "Dhamura", "bn_name": "" },
    { "id": "483", "district_id": "116", "name": "Jugirkanda", "bn_name": "" },
    { "id": "483", "district_id": "116", "name": "Shikarpur", "bn_name": "" },
    { "id": "483", "district_id": "116", "name": "Uzirpur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "116", "name": "Uzirpur Sadar", "bn_name": "" },
    { "id": "483", "district_id": "116", "name": "Wazirpur Bazar", "bn_name": "" },



    { "id": "483", "district_id": "117", "name": "Abhohawa Office Road", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Ali Nagar", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Bangla School Mor", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Banker Hat", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Bhola Bapta", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Bhola Boys School Road", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Bhola Central Post Office", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Bhola Collage Road", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Bhola Girls Collage Road", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Bhola Natun Bazar", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Bhola Pranishompod Road", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Bhola Sadar", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Bhola Sadar Hospital Road", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Bhola Ukil Para", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Borhanuddin UPO", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Charfashion", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Char Kalmi", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Chornoyabad", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Chorshami", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Daurihat", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Dorga Road", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Doulatkhan", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Dularhat", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Gazaria", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Hajipur", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Hajirhat", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Hatshoshiganj", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Jamiralota", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Joynagar", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Kalibari Road", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Kalikhola Road", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Keramatganj", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Lalmohan UPO", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Mirzakalu", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Monpura", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Mostofa Kamal Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Nasir Mazi", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "New Elisha Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Nobi Pur", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Old Elisha Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "P.T.I Road", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Pouro Khathali", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Roton Pur", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Sodurchar", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Tazumuddin", "bn_name": "" },
    { "id": "483", "district_id": "117", "name": "Western Para", "bn_name": "" },



    { "id": "483", "district_id": "118", "name": "Alam Market", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Amtola Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Amua", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Amua Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Amua Zero Point", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Aorabunia Dokkhinpar Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Bablatola Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Baidarapur", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Banai Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Bashonda", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Baukathi", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Beerkathi", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Bhairabpasha", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Bhavanipur Launch Station", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Binapani Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Binoy Khathi", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Bisic Silponogori Jhalokhati", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Bot Tola Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "C&B Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Centrer Hat", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Chailar Char", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Charukhan", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Dapdapia Launch Ghat", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Darul Habib Khanka Sharif Dapdapia Barishal", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Deulkati", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Dibakorkathi", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Dopdipia Fish Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Eidgar Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Fokir Market", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Gabha", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Gabkhan", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Galua Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Gopalpur Pochchim Para", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Guachitra Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Guhuder Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Hadua Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Hodua Launch Terminal", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Islamia Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Jhalokati Sadar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Kachua Ferry Terminal", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Kathalia", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Khejurtala Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Kirtipasha", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Kolakopa Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Kulkhathi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Latimsar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Magar Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Mahtab Malta Bagan", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Manpasha", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Mohajon Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Mollar Hatt Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Morichbunia Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Mothbari", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Munsirabad Bazar Jhalokati Shouljalia", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Nabagram", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Nalchhiti", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Nathullabadh", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Navagram", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Niamatee", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Notun Hath Bazar Jhalokathi Ranapasha", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Noyarasta Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Ostakhan Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Panchagram Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Patikhal Ghata Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Pingri", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Ponabalia Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Protap", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Rajapur", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Rajapur Jhalokatii", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Satani Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Shakherhat", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Shameer Hat", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Shekherhat", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Shoulajalia", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "South Palot Launch Terminal", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Taltola Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Tekerhat Bazar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Ukel Bazzar", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Uttar Bikna", "bn_name": "" },
    { "id": "483", "district_id": "118", "name": "Zahatola Bazar", "bn_name": "" },



    { "id": "483", "district_id": "119", "name": "Auliapur", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Bagabandar", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Barabighai", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Bauphal", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Birpasha", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Char Montaz", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Dashmina", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Dumkee", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Galachipa", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Gazipur Bandar", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Hetalia Badhghat", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Jainkathi", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Kalaia", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Kalapara - Galachipa", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Kalishari", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Katpotti", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Khepupara", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Kuakata", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Lebukhali", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Lohalia", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Mahipur", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Marichbunia", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Mirjaganj Sarak", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Mitha Pukur Par", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Moukaran", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Mukul Cinema Hall", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Nobab Para", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Patuakhali Banani", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Patuakhali Jailkhana Road", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Patuakhali Medical College Hospital", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Patuakhali Notun Bazar", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Patuakhali Pourosova", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Patuakhali Puran Bazar", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Patuakhali Sadar", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Patuakhali Shilpokola Academy", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Rahimabad", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Rangabali", "bn_name": "" },
    { "id": "483", "district_id": "119", "name": "Subidkhali", "bn_name": "" },



    { "id": "483", "district_id": "120", "name": "Amla Para", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Banaripara", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Betmor Natun Hat", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Bhandaria", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Bolaka Club Road", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Bolassor Bridge", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Boro Mosjid", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "C.I Para", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Chakhar", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Damudar Bridge", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Darus Sunnat", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Dhaoa", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Dokhin Shikar Pur", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Dopa Bara", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Duppasa", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Gulishakhali", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Halta", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Hularhat", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Jalabari", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Jolagati", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Joykul", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Kanudashkathi", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "KaukhaliKaukhali", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Kaurikhara", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Keundia", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Masim Pur", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Matani Road", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Mathbaria", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Mohila College Road", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Muchi Para", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Nazirpur", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Nirer Goli", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Parerhat", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Adarsha Para", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Boropul", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Bot Tola", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur College Road", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Dc Office", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Judge Court", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Lged", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur New Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur P.T.I Road", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Palpara", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Police Line", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Police Station", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Post Office", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Pouro Shoshan", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Puran Pouroshova Road", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Sadar", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Sadar Hospital", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Sadar Thana", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Surgicare", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Town Club", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Pirojpur Ukil Para", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Rajar Hat", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Sheik Para", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Shikha Office", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Shilarganj", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Sriramkathi", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Swarupkathi", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Tiarkhali", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Tushkhali", "bn_name": "" },
    { "id": "483", "district_id": "120", "name": "Yasinkhar Pol", "bn_name": "" },



    { "id": "483", "district_id": "121", "name": "Balaganj Begumpur", "bn_name": "" },
    { "id": "483", "district_id": "121", "name": "Balaganj Brahman Shashon", "bn_name": "" },
    { "id": "483", "district_id": "121", "name": "Balaganj Gaharpur", "bn_name": "" },
    { "id": "483", "district_id": "121", "name": "Balaganj Goala Bazar", "bn_name": "" },
    { "id": "483", "district_id": "121", "name": "Balaganj Karua", "bn_name": "" },
    { "id": "483", "district_id": "121", "name": "Balaganj Kathal Khair", "bn_name": "" },
    { "id": "483", "district_id": "121", "name": "Balaganj Natun Bazar", "bn_name": "" },
    { "id": "483", "district_id": "121", "name": "Balaganj Omarpur", "bn_name": "" },
    { "id": "483", "district_id": "121", "name": "Balaganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "121", "name": "Balaganj Tajpur", "bn_name": "" },


    { "id": "483", "district_id": "122", "name": "Beanibazar Beanibazar", "bn_name": "" },
    { "id": "483", "district_id": "122", "name": "Beanibazar Churkai", "bn_name": "" },
    { "id": "483", "district_id": "122", "name": "Beanibazar jaldup", "bn_name": "" },
    { "id": "483", "district_id": "122", "name": "Beanibazar Kurar bazar", "bn_name": "" },
    { "id": "483", "district_id": "122", "name": "Beanibazar Mathiura", "bn_name": "" },
    { "id": "483", "district_id": "122", "name": "Bianibazar Salia bazar", "bn_name": "" },


    { "id": "483", "district_id": "123", "name": "Bishwanath Bishwanath", "bn_name": "" },
    { "id": "483", "district_id": "123", "name": "Bishwanath Dashghar", "bn_name": "" },
    { "id": "483", "district_id": "123", "name": "Bishwanath Deokalas", "bn_name": "" },
    { "id": "483", "district_id": "123", "name": "Bishwanath Doulathpur", "bn_name": "" },
    { "id": "483", "district_id": "123", "name": "Bishwanath Singer kanch", "bn_name": "" },


    { "id": "483", "district_id": "124", "name": "Dowbangla", "bn_name": "" },
    { "id": "483", "district_id": "124", "name": "Fenchuganj Fenchuganj", "bn_name": "" },
    { "id": "483", "district_id": "124", "name": "Fenchuganj Fenchuganj SareKarkh", "bn_name": "" },




    { "id": "483", "district_id": "125", "name": "Goainhat Chiknagul", "bn_name": "" },
    { "id": "483", "district_id": "125", "name": "Goainhat Goainhat", "bn_name": "" },
    { "id": "483", "district_id": "125", "name": "Goainhat Jaflong", "bn_name": "" },


    { "id": "483", "district_id": "126", "name": "Banigram", "bn_name": "" },
    { "id": "483", "district_id": "126", "name": "Bhadeshwar", "bn_name": "" },
    { "id": "483", "district_id": "126", "name": "Budhbari Bazar", "bn_name": "" },
    { "id": "483", "district_id": "126", "name": "Dhaka Dakkhin", "bn_name": "" },
    { "id": "483", "district_id": "126", "name": "Golapganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "126", "name": "Jalalpur", "bn_name": "" },
    { "id": "483", "district_id": "126", "name": "Kotalpur", "bn_name": "" },
    { "id": "483", "district_id": "126", "name": "Ranaping Bazar", "bn_name": "" },
    { "id": "483", "district_id": "126", "name": "Shekhpur", "bn_name": "" },
    { "id": "483", "district_id": "126", "name": "West Barokut", "bn_name": "" },


    { "id": "483", "district_id": "127", "name": "Azmireeganj", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Bahubal", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Bahubal Putijuri", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Baniachang", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Baniachang Jatrapasha", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Baniachang Kadirganj", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Chunarughat", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Chunarughat Chandpurbagan", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Chunarughat Narapati", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Habiganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Habiganj Sadar Gopaya", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Habiganj Sadar Shaestaganj", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Madhabpur", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Madhabpur Itakhola", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Madhabpur Saihamnagar", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Madhabpur Shahajibazar", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Nabiganj", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Nabiganj Digalbak", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Nabiganj Golduba", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Nabiganj Goplarbazar", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Nabiganj Inathganj", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Shaestaganj Gonganagar", "bn_name": "" },
    { "id": "483", "district_id": "127", "name": "Sheaestaganj Shankhola Bazar", "bn_name": "" },


    { "id": "483", "district_id": "128", "name": "Zakiganj Bazar", "bn_name": "" },
    { "id": "483", "district_id": "128", "name": "Zakiganj Ichhamati", "bn_name": "" },
    { "id": "483", "district_id": "128", "name": "Zakiganj Sadar", "bn_name": "" },



    { "id": "483", "district_id": "129", "name": "Kanaighat Chatulbazar", "bn_name": "" },
    { "id": "483", "district_id": "129", "name": "Kanaighat Sadar", "bn_name": "" },
    { "id": "483", "district_id": "129", "name": "Lakhsmi Prasad", "bn_name": "" },
    { "id": "483", "district_id": "129", "name": "Rajaganj", "bn_name": "" },




    { "id": "483", "district_id": "130", "name": "Akhailkura", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Bahar Mordan", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Banani", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Baralekha Baralekha", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Baralekha Dhakkhinbag", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Baralekha Purbashahabajpur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Baronti", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Bhairabganj Bazar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Borhat", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Borshijura", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Boruna", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Buddhimontopur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Damia", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Dighirpar - Moulvibazar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Durlovpur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Ekatuna", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Ghumra", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Giasnagar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Gobindopur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Gujarai", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Hilalpur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Jagatshi", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Jogonnathpur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Jugidor", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kadamhata", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kalapur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kalenga", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kamalganj", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kamalganj Keramatnaga", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kamalganj Munshibazar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kamalganj Patrakhola", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kamalganj Shamsher Nagar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kamalpur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kazir Bazar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Konokpur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kulaura Baramchal", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kulaura Bhatera", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kulaura Bhukshimail", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kulaura Kajaldhara", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kulaura Karimpur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kulaura Kulaura", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kulaura Langla", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kulaura Prithimpasha", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Kulaura Tillagaon", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Maliksorai", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Mamrokpur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar - Islampur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Afrozganj", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Berirpar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Bonobithi", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Chandinighat", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Chowmuhona", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Court Road", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Darga Moholla", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Dhaka Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Dhorkapon", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Kazirgaon", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Kolimabad", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Kusumbag", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar M. Saifur Rahman Road", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Matarkapon", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Monumukh", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Mostafapur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Muslim Quarter", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Old Hospital Road", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Shah Mostafa Road", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Shantibag", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Sunapur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Syed Mujtoba Ali Road", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Moulvibazar Sadar Wapda Gate", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Mukambazar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Munshi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Nadampur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Noldaria", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Police Line", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Polytechnic Institute", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Premnagar Tea Estate", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Radar Unit", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Raipur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Rajnagar Fatehpur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Rajnagar Munshibazar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Rajnagar Sadar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Rajnagar Tarapasha", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Rajnagar Tengra", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Roghunondonpur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Sabia", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Sarkarbazar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Shah Bandar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Shamorkuna", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Sherpur Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Shompashi", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Shomserganj", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Shomsernagar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Shomsernagar Airport", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Soiyarpur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Sreemangal", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Sreemangal Kalighat", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Sreemangal Khejurichhara", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Sreemangal Narain Chora", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Sreemangal Satgaon", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Sunapur", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Taltola Baramchal", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Thana Bazar", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Uluail", "bn_name": "" },
    { "id": "483", "district_id": "130", "name": "Uttor Mulaim", "bn_name": "" },



    { "id": "483", "district_id": "131", "name": "Bishwamvarpur", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Chhatak", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Chhatak Cement Factory", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Chhatak Chourangi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Chhatak Gabindaganj", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Chhatak Gabindaganj Natun Bazar", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Chhatak Islamabad", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Chhatak jahidpur", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Chhatak Khurma", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Chhatak Moinpur", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Chhatak Paper Mills", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Derai Chandpur", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Derai Sadar", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Dowarabazar", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Ghungiar", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Jagannathpur Sadar", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Jagnnathpur Atuajan", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Jagnnathpur Hasan Fatemapur", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Jagnnathpur Rasulganj", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Jagnnathpur Shiramsi", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Jagnnathpur Syedpur", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Jamalganj", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Rangarchar", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Sachna", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Selborash", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Sunamganj Civil Surgeon Office", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Sunamganj Madhyanagar", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Sunamganj Sadar Hospital", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Sunamganj Sadar Pagla", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Sunamganj Sadar Patharia", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Sunamganj Sadar Sunamganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Surma", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Tahirpur", "bn_name": "" },
    { "id": "483", "district_id": "131", "name": "Tarol", "bn_name": "" },



    { "id": "483", "district_id": "132", "name": "Akhalia", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Alampur", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Ambarkhana", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Badam Bagicha", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Baghibari", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Bhatalia", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Bil Par", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Bimanbondarair Road", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Boroikandi", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Charadigirpar", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Chondan Tula", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Choukidighi", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Daptari Para", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Dargah Mahalla", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Darjee Band", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Dattapara", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Gasitula", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Golapganj", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Haripur", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Hatimbagh", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Hauldar Para", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Hawapara", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Jalalabad", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Jalalabad Cantonment", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Jamtala", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Jherjheri Para", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Jointapur", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Kahar Para", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Kajal Shah", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Kalapara", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Kalighat", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Kamalbazer", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Kanisail", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Kazi Jalaluddin Mahalla", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Keyapara", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Khadimnagar", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Khadim Para", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Kharadi Para", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Khasdobir", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Khujarkhola", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Korarpar", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Kuarpar", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Kuliapara", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Kurshi Ghat", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Lakri Para", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Lala Bazar", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Lalbazar", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Lal Dighirpar", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Lama Bazar", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Lawai", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Majumder Para", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Mazumdari", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Mirapara", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Mir Boxtula", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Mirza Jangal", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Modhu Shahid", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Mominkhola", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Mongla", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Mulla Para", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Munshipara", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Nabab Road", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Nehari Para", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Noapara", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Pathan Tula", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Pir Mahalla", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Ponitula", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Puran Lane", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Rajargali", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Raj Bari", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Rajpara", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Ranga Hajiganj", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Sabuj Bagh", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Sadatikar", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Sadipur", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Sagardigir Par", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Sarderpar", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Shahajalal University Sylhet", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Shah Jalal University (SUST-Akaliya)", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Shaplabagh", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Shenpara", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Shibganj - Khoradi Para", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Silam", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Sylhet Biman Bondar", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Sylhet - Kadamtali", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Sylhet Sadar Upazilla Office", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Taltola Road", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Tero Ratan", "bn_name": "" },
    { "id": "483", "district_id": "132", "name": "Tilagor - Tatipara", "bn_name": "" },




    { "id": "483", "district_id": "133", "name": "Bashundhara R/A", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Abul Hotel Bus Stop", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Abur Tek Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "ACS Garments (Ati Para)", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Adabor", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Adam Ali Market", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Adarsha Bag", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Aftab nagar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Agargaon", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Ahmed Nagar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Akij Foundation", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Al Huda Mosjid", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Ananda Nagar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Apollo Hospital", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Arjat Para", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Ark Hospital", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Armanitola", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Army Society", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Army Stadium", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Asad Gate", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Ashalota", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Ashkona", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Ashkona Boro Mosjid", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Ashkona Dilder Bari", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Ashkona Mosjid Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Ashkona Panir Pamp", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Atipara Bazar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Azompur Brac Market", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Badda", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Badda Hossain Market", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bagbari", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Baily Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Baitul Azam Mosjid", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Balughat", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Banani Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Banani DOHS", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Banani Graveyard", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Banani Naval Head Quarter", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Banani Road No. 1 - 11", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Banani Road No. 12 - 19", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Banani Road No. 20 - 28", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Banasree Block A", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Banasree Block C", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Banasree Block D", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Banasree Block E", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Banasree Block J", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Banasree Block K", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Baridhara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Baridhara DOHS", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Barontek", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bashtola", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bashundhara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bashundhara Block A", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bashundhara Block B", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bashundhara Block C", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bashundhara Block D", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bashundhara Block F", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bashundhara Block H", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bashundhara Block I", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bashundhara Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Baunia", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bawlia Para", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bawneabad Area", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Begunbari", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bepari Bari", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bhuyia Para", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bishteki", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Bonolota", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Borobagh", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Box Nagar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "CDH Shampan", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Chairman Para", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Chamurkhan", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Chittagong Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "City Complex Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Coca Cola Bus Stop", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Confidence Shopping Mall", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Darus Salam", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Dewan Bari", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Dewan City", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Dhaka - Cantonment", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Dhaka - North City Corporation Market", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Dhakinkhan Bazar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Dhamrai", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Dhoronggar Tek", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Diabari", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Dobadia", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Doctor Goli", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Dokkhingao", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Dour", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "East Hazipara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "East Merul Badda", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "East Nakhalpara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "East Nurerchala", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "East Rampura", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "East West Medical College", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Faidabad Mor", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Faidabad Police Fari", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Faidabad Prmary School", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Farid Market", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Farmgate", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Gabtoli Bus Terminal", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Gawair", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Golartek", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Gono Koborshathan Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Goran Tampoo stand", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Gulshan 1", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Gulshan 2", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Gulshan Badda link Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Hatim Bag", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Hatirjheel", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Hazi Camp", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Helal Market", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Holan", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "House Building", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Ibrahimpur", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "ICDDRB", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "IUBAT", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Jahangir Gate", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Jahurul Haque City", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Jamtola", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Jamuna Future Park", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Jashimuddin Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Joar Shahara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Joynal Market", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kacha Bazar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kachkura", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kafrul", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kalachandpur", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kallyanpur", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kamar Para", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Karwan Bazar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kathal tola", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kawranbazar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kazi Bari", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kazipara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Khilgoan Bus stop", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Khilkhet", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Koloni Bazar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kosai Bazar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Koshaibari", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kunipara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kuril", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kuril bus stop", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Kurmitola", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Malibag bus stand", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Malibag railgate", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Manikdi", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Master Para Bazar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Masterpara Kola Bagan", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Master Para Munda", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Matikata", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mazi Bari", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Medical Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Meradia", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Meradia Graveyeard", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Meradia kacha bazar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Merul", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Miapara Mosjid Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Middle badda", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Middle Meradia", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirbag", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur 1", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur 10", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur 60 Feet", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Botanical Garden", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Cantonment", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Ceramic", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Darus Salam", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur DOHS", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Govt Housing Estate", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Kazipara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Rupnagar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 1", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 11", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 12", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 13", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 14", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 15", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 16", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 2", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 3", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 4", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 5", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 6", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 7", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 8", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Section 9", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Shewrapara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Taltola", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mirpur Zoo", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Modhubag", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mohakhali", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mohakhali Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mohakhali DOHS", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mohakhali Inter District Bus Terminal", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mohakhali Kachabazar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mohakhali koraill Basti", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mohakhali TB Gate Jame Mosjid", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mohammadia Housing Limited", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mohammadpur Chandmiya Housing", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mohammadpur Mohammadia Housing Society", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mohammadpur Mohammadia Non Housing Area", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mohammadpur P C Culture Society", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mohammadpur Residential Area", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Moinar Tek", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mojibur Market", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Molla Para", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mollartek", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Monipur", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Monipuri Para", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Mouchak Market", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Muktijoddha Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Munsi Market", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Nabisco Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Nadda", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Nagoria Bari", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Nakhalpara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Nama Para", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Nasir er tek", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Neoyazbag", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Niketon", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Niketon Bazar gate", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Nikunja 1", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Nikunja 2", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Nishat Nagar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Noddapara Club Mor", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Noddapara Mosjid Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Nogor Bari", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Nondipara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Nondipara Bazar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Nondoni Para", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Notunbag", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Notunbazar Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Noyatola", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Nurer Chala", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Paikpara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Paschim Rampura", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Peyara Bagan", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Pink City", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Pirerbagh", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Police Plaza", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Prembagan", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Primary School", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Pular Tek", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Rajabari Mor", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Rajarbag Kalibari", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Ramjan Market", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Rampura Bazar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Rampura Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Rana Vola", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Rasulbagh", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Rupali Garden", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Rupali Tower", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Satrasta", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Shahinbag", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Shahjahadpur Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Shahjahdpur", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Shamol Bagh", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Shantiniketon", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Shantipur", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Sharnalata", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Shena Maloncha", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Shenpara Parbata", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Sher-e-Bangla Nagar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Shewrapara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Shiddheshwari", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Shipahibag", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Shonirakhra", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Shyamoli", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Sipahi bag tampoo stand", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Solmaid", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Sona katra", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Sorkar Para", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "South Badda", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "South Banashree", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Subastu Nogorvally", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Taltola Khilgoan", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Taltola Mor", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Taltola Mosjid Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Tejgaon", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Tejgaon - Gulshan Link Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Tejgaon Industrial Area", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Tejkunipara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Tek para", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Television Museum", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Tetul Tola", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Tibbet Factory", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "TIC Colony Mor", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Tilpa Para", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Titas Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Transmitter Mor", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Trimohoni Bazar", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Trimohoni Bridge", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Truckstand", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Ulon", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Update Dental College", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Airport", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Ajompur", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Majar Road", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 1", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 10", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 11", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 12", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 13", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 14", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 15", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 2", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 3", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 4", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 5", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 6", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 7", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 8", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttara Sector 9", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttar Badda", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Uttargao", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Vashantek", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Vatara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Vatara Mor", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "West Hazipara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "West Nakhalpara", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "West Rampura", "bn_name": "" },
    { "id": "483", "district_id": "133", "name": "Wireless More Bus Stop", "bn_name": "" },



    // =======================================


    { "id": "483", "district_id": "134", "name": "New/Old Ak School", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Abdul Bani Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Abdul Hadi Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Abed Dali Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Abhidas Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Abul Hasnat Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Abul khairat Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Agamasi Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Aga sadek road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Ahmedbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Ahsan Ullah Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Alamganj Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Al Amin Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Aminabad colony moghbaraz", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Aminbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Anond mohan boshak Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Arambagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Armenium Street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Ashik lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Ayub Ali colony Rahim square", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Azimpur", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Azizullah Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bagamganj Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bagdasa Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bahadurpur Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bailey Square Moghbazar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Baitul Mukarram Stadium", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bakshibagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Banasree", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bandura Nawabganj", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bangabandhu Avenue & Rest House", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bangabhaban", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bangladesh Bank Colony", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bangladesh Railway Barracks", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bangshal", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bangshal Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Barnamala School", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Basabo", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bashabo Ohaba Colony", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bashir uddin road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bashundhara City", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Basu Bazar Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "BDR Pilkhana", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Begum Bazar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bhagwati Banerjee Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bhanga Press", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bhojhari Saha Street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Bijoy Nagar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Central prison", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "central public library", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Chamelibagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Chandi Charan Bose Street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Chankharpul lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Chan Para", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "ChanPara Zia Bagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Chawk Bazar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Chota Katra", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Circular Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Committee ganj", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Court House Street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "D.C Court", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dayaganj Jelepara", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dayaganj Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "DC Roy Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Deen Nath Sen Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Demra", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhaka Cotton Mills", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhaka medical college", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhaka University", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhakeshwari Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhalpur", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 1", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 10", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 10A", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 11", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 11A", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 12", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 12A", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 13", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 13A", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 14", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 15", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 16", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 17", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 18", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 19", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 1A", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 2", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 20", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 21", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 22", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 23", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 24", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 25", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 26", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 27", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 28", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 29", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 2A", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 3", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 30", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 31", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 32", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 3A", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 4", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 4A", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 5", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 5A", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 6", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 6A", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 7", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 7A", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 8", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 8A", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 9", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi 9A", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dhanmondi Staff Quarter", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dholaipar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dilkusha", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dilkusha Commercial Area", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Dr. M A Rashid Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "East Bashabo", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Eastern Housing", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "East Raibazar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Elephant Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Engineering University & Residential Area", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "English Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Eskaton Garden Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Fakirapul", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Fakirapul Market Area", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Farashgang Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Faridabad Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Folder Street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "French Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Fulbaria Station East Area", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Ganguly Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Gendaria", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Gendaria Rail Gate", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Ghaji Osman Gani Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Golakpal Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Golam Mostafa Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Gopibagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Gopinath Dutt Kabiraj Street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Goran", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Govinda das lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Green corner green road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Green Corner paribag", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Green Road East", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Green Road Staff Quarter", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Green Road West", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Green Square", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Gulbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Gulistan", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Hafiz Ullah Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Haji Afsaruddin Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Haji Mohammad Moshin Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Hakim Habibur Rahman Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Haricharan Roy Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Harish chand lane basu street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Hari Street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Hatembagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Hatirpool Free school Street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Hatkhola Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Hazaribagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Hazi mainuddin Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "High court Staff quarter", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Imam Gang", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Indrapuri", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Jagannath Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Jatrabari", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Jatrabari Arot", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Jayakali Mandir Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Jhauchor", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Judge Court", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "K.M Azam Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "K.Pk Ghosh Street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kadamtala", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kadamtali", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kajla", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kakrail", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kalabagan", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kalabagan Free School Street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kalma Market", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kamalapur", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kamlapur", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kamrangirchar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kanchpur", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Karimullarbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kasaituly", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Katherpul Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kazirbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kazi Zia uddin Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kedar Nath", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Khilgaon", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Khilgaon Bagicha", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Khilgaon Colony", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "K M Das Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Konapara", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kutubkhali", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Kuwait friendship hospital", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Lalbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Lalmatia", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Lal Mohan Poddar Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Lalmohan Shah Street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Large katra", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Madan Mohan Basak Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Madanshah Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Madartek", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Madinabagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Malakartola Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Malibag", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Malibagh Bazar Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Malitola lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Maniknagar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Manik Nagar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Manik Nagar Miyazan Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Maradia", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Matuail", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Mayakanon", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Merajnagar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Methorpotty", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Middle Bashabo", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Mill Barracks", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Mintu Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Mir Hazaribagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Mitali road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Mitfort Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Mogbazar Circuit House Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Moghbazar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Moghbazar TNT colony", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Mohhammadbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Mohini Mohandas Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Mokim Katara", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Momenbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Motijheel", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Motijheel Colony", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Motijheel Commercial Area", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Mugda", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Mugdapara", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Mujahid Nagar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Municipal Staff Quarter", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Munir Hossain Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Muradpur", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Mymensingh lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Nabalka Mia lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Narinda Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Narinda Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "National Museum Quarter", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Naveen Chandra Gombasi Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Nawab Deori", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Nawab Katara", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Nawab Street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Nayapalton", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Nazira Bazar Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Nazrul Islam Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Neki Deori", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "New Eskaton Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "New Jurain Alam Bagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "New market", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Nilkhet Babupara", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Noor box Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "North Bashabo", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "North Circular Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "NorthEast Bashabo", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "North Jatrabari", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "North Mugdapara Deputy Colony", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "North Rajarbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "North Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "NorthWest Jatrabari", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Outer Circular Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Padmolochan Roy Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Palamganj", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Pallabi", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Palton", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Paribagh Shah Sahib Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Patlakhan Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Patuatuli Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "PG Hospital", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Poet Jasim Uddin Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Police Hospital", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Postagola", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Postal Colony", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Purana Paltan GPO", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Purana Paltan Line", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Puran Dhaka - Islampur", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Puran Para", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Railway Hospital area", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Rajabagh Police Line", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Rajani Bose Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Rajani Chowdhury Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Rajarbag Police Line", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Rakhal chandra bashak lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Ramna", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Rampura", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Rayerbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Rishikosh Das Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "R K Mission Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Roisnagar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Rokaya Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Rupa das lal lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Rupchan Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Sabujbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Saddam Market", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Saidabad", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Salimullah Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Samaswada lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Sarulia", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Satish Sarkar Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Satmasjid Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Sayed hasan Ali Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Secretariat Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Segun Bagicha", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shahbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shaheed Memorial Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shahidbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shahidullah Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shahjahanpur", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shahjahanpur Railway Colony", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shah Shaheb Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shakhari Bazar Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shakhari Nagar Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shampur", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shamsun Nahar Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shantibagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shantinagar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shantinagar Market Area", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Sharat chandra chakraborty lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Sharatgupta Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shashibhushan Chaterjee Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Sheikdi", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Sheikh Majibur Rahman Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Sherabangla Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Sher e Bangla Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shukrabad", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Shurwardi Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Siddheshwari Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Siddique bazar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Siddique lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Simson Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Sir AF Rahman hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Sobhanbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Sohidnagar", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Sonali Bank Colony", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "South Bashabo", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "SouthEast Jatrabari", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "South Jatrabari", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "South Khilgaon", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "South Rajarbagh", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Surya Sen Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Sutrapur", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Swamibagh Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Swamibagh New Township", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Swarighat east", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "T & T Colony", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Tallabag", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Tanuganj Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Thakurdas Lane", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Tikatuli", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Tipu Sultan Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Titumir Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Topkhana Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Toynbee Circular Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Walter Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Wapda Colony", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Wari", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Wari Street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "West Bashabo", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "West End Street", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "West fulbarai area", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "West Jatrabari", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "West Juraine", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "West Malibag", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "WHO Mission Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Wise Ghat Road", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Zahur Haque Hall", "bn_name": "" },
    { "id": "483", "district_id": "134", "name": "Ziaur Rahman Hall", "bn_name": "" },




    { "id": "483", "district_id": "135", "name": "Alfadanga", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Alipur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Ambikapur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Ambikapur Board Office", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Atrashi Sadarpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Bagat Bazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Baitul Aman Housing Society", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Baitulaman Politecni", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Bakhunda", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Bhanga", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Bhashanchar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Bil Mamudpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Boalmari", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Bodorpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "C&B Ghat", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Charbhadrasan Upazila Faridpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Char Hazigonj Bazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Chorkomlapur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Chunaghata", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Dhuldi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Dhuldi Railgate", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Durgapur Faridpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Engineering College", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Faridpur New Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Faridpur New Market", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Faridpur Sadar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Gojaria Bazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Goldangi Faridpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Hat Krishnapur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Horishova", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Hotath Bazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Ishan Gopalpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Jhiltuli", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Kamarkhali", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Kanaipur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Kanaipur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Kanaipur Tetul Tala", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Khabaspur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Khaleque Bazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Khalilpur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Khusir Bazar Faridpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Kobirpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Komlapur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Komorpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Krishi College", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Laler Mor", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Maligram Bhanga", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Mamudpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Medical", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Modhukhali Upozila Faridpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Mohammadpur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Mohila Road", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Momin Khar Hat", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Munshibazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Nagarkanda Upazila Faridpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Niltuli", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Old Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Onather Mor", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Peyarpur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Pirerchor Bhanga", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Poranpur Bazar Faridpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Puran Gazi Bari", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Sadarpur Upazila Faridpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Sadipur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Saltha Upazila Faridpur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Sovarampur", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Station Bazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Talma Bazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Tepakhola", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "Vai Vai Bazar", "bn_name": "" },
    { "id": "483", "district_id": "135", "name": "West Khabaspur Faridpur", "bn_name": "" },







    { "id": "483", "district_id": "136", "name": "Ahmed Nagor Chowrasta", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Ambag", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Ansar Academy", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Apex Footwear Factory", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Bagher Bazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Bahadurpur - Mowna Gazipur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Bahawalpur College Chowrasta", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Barmi", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Bashon Thana Chowrasta", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Bason Sorok", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Boadmill", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Board Bazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "BRRI", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Brtc Chowrasta", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Chanda Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Chanda Palli Bidyut", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Chandra Baroipara", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Chandra Kobirpur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Chatar Bazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Chowrasta Baypass", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Chowrasta Telipara", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Chowrasta Warelessgate", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Colombia Garments", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Deger Chala Road", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Dhakkinan Joydebpur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Dhakkin Chaybithi", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Dhaladia Bazar - Mowana Gazipur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Dhirashom Joydebpur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Dird Composit - Mowna Gazipur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Dukan Par", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Epsha Gate - Mowna Gazipur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Gazipur Bot Tola Auto Stand", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Gazipur Bscic", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Gazipur Caller Bazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Gazipur Palli Biddyut", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Gazipur Sadar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Great Wall City", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Harikan Road", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Hazir Pukur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Horinhati", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Hotapara", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Islam Garments", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Islamic University", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Jel khana", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Jorun", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Joydebpur Police Line", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Joydebpur Rail Gate", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kadda Bazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kaliakaar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kaliakoir Board Ghar Bazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kaliakoir Chandra Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kaliakoir Fulbaria", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kaliganj", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kamar Juri", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kapashia Barishab", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kapashia Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kapashia Chandpur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kapashia Durgapur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kapashia Ghagotia", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kapashia Karihata", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kapashia Rayed", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kapashia Sonmania", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kapashia Tokh", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kapasia Bazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kapasia Chala Bazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kashimpur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kashimpur Hatimara", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Konabari Bashtola", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Konabari Nawjor", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Konabari Palli Biddyut", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Konabri College Gate", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Kudusnagor - Nill Nagor", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Laxmipura", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "LIDA Textile", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Mahona Bhabanipur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Maleker Bari", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Maona Baro Topa", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Maona C and B Bazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Maona Chowrasta", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Maona Mc Bazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Maona Noyonpur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Maona Soling Mor", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Masterbari - Mowna Gazipur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Mazar Road Riad", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Member Bari", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Mirzapur - Mowna Gazipur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Mogorkal - Doshtola", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Monipur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Monnunagar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Mouchak", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Mouchak Cha Bagan", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Mouchak Vannara", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "National University", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Noyapara - Mowna Gazipur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Open University", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Parijat", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Polagach Road", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Purabari - Mowna Gazipur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Purbachal Stellmill Road", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Rajbari Math Joydebpur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Rajendrapur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Rajendrapur Cantonment", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Rotonpur Railway", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Salna - Mowna Gazipur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Shafipur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Shafipur Boroibari", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Shafipur Shinabaha Bazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Sharifpur Road", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Shimultoli Joydebpur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Sign Board", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Sreepur", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Sreepur Amraid", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Sreepur Gosinga", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Sreepur Joinabazar", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Sreepur Kawraid", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Sreepur Rajabari", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Sreepur Telihati", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Uttor Chayabithi", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Vushir Mill", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Zirani", "bn_name": "" },
    { "id": "483", "district_id": "136", "name": "Zora Pump", "bn_name": "" },




    { "id": "483", "district_id": "137", "name": "Arpara", "bn_name": "" },
    { "id": "483", "district_id": "137", "name": "Gopalganj Dhaka Dakkhin", "bn_name": "" },
    { "id": "483", "district_id": "137", "name": "Gopalganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "137", "name": "Gopalganj Sadar Ulpur", "bn_name": "" },
    { "id": "483", "district_id": "137", "name": "Gopinathpur", "bn_name": "" },
    { "id": "483", "district_id": "137", "name": "Kashiani", "bn_name": "" },
    { "id": "483", "district_id": "137", "name": "Kashiani Ramdia College", "bn_name": "" },
    { "id": "483", "district_id": "137", "name": "Kotalipara", "bn_name": "" },
    { "id": "483", "district_id": "137", "name": "Maksudpur", "bn_name": "" },
    { "id": "483", "district_id": "137", "name": "Malenga", "bn_name": "" },
    { "id": "483", "district_id": "137", "name": "Manikher", "bn_name": "" },
    { "id": "483", "district_id": "137", "name": "Ratoil", "bn_name": "" },
    { "id": "483", "district_id": "137", "name": "Tungipara", "bn_name": "" },
    { "id": "483", "district_id": "137", "name": "Vatiapara", "bn_name": "" },




    { "id": "483", "district_id": "138", "name": "Abdullahpur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "138", "name": "Ati bazar", "bn_name": "" },
    { "id": "483", "district_id": "138", "name": "Basundhara", "bn_name": "" },
    { "id": "483", "district_id": "138", "name": "Dohar", "bn_name": "" },
    { "id": "483", "district_id": "138", "name": "Ekuriya", "bn_name": "" },
    { "id": "483", "district_id": "138", "name": "Hasnabad", "bn_name": "" },
    { "id": "483", "district_id": "138", "name": "Kaligonj", "bn_name": "" },
    { "id": "483", "district_id": "138", "name": "Keraniganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "138", "name": "Kodomtoly", "bn_name": "" },
    { "id": "483", "district_id": "138", "name": "Konakhola", "bn_name": "" },
    { "id": "483", "district_id": "138", "name": "Konda", "bn_name": "" },
    { "id": "483", "district_id": "138", "name": "Ramerkanda", "bn_name": "" },
    { "id": "483", "district_id": "138", "name": "Rohitpur", "bn_name": "" },
    { "id": "483", "district_id": "138", "name": "Stand Bazar", "bn_name": "" },
    { "id": "483", "district_id": "138", "name": "Zinzira", "bn_name": "" },



    { "id": "483", "district_id": "139", "name": "Abdullahpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Ashutia Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Austagram Adampur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Austagram Bangal Para", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Austagram Deoghar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Austagram Kalma", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Austagram Kastul", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Austagram Khayerpur Abdullahpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Austagram Purba Austagram", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bajitpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bajitpur Baliadi", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bajitpur Dighirpar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bajitpur Dilalpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bajitpur Gazir Char", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bajitpur Halimpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bajitpur Hilachia", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bajitpur Humaipur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bajitpur Kailag", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bajitpur Maij Char", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bajitpur Pirijpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bajitpur Sarar Char", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Banagram Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bawlai", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Beltoly Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bhairab", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bhairab Aganagar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bhairab Gazaria", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bhairab Kalikaprashad", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bhairab Sadekpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bhairab Shibpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bhairab Shimulkandi", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Bhairab Sreenagar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Binnadi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Binnati", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Borpul ar mor", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Boulai Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Chadurar Pool Putimari", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Chamraghat Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Chauddasata", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Dana Patuli", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Haruya", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Hossaindi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Hossainpur Araibari", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Hossainpur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Hossainpur Gobindapur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Hossainpur Jirani", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Hossainpur Pumdi", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Hossainpur Sahedal", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Hossainpur Sidhla", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Hossenpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Itna Badla", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Itna Baribari", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Itna Chowganga", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Itna Dhanpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Itna Elongjuri", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Itna Gazipur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Itna Joysiddi", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Itna Mrigha", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Itna Raituti", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Jalalpur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Jamtola Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Jangalia Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Jasodal", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Josudal Syed Nazrul Islam Medical", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Joybangla Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Karimganj", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Karimganj Baragharia", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Karimganj Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Karimganj Dehunda", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Karimganj Gujadia", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Karimganj Gundhar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Karimganj Jafarabad", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Karimganj Joyka", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Karimganj Kadir Jungle", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Karimganj Niamatpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Karimganj Noabad", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Karimganj Sutar Para", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Katiadi", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Katiadi Achmita", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Katiadi Banagram", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Katiadi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Katiadi Chandpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Katiadi Gochhihata", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Katiadi Jalalpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Katiadi Kargaon", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Katiadi Luhajuri", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Katiadi Masua", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Katiadi Mumurdia", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Katiadi Shaha Dhulia", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Kawna Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Khilpara", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Kishoreganj Bottrish", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Kishoreganj Chamra Bandar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Kishoreganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Kishoreganj Sadar S.Mills", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Kishoreganj Sadar S.Mills", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Korsha Kariail", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Kuliarchar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Kuliarchar Chhaysuti", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Kuliarchar Faridpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Kuliarchar Gubaria Abdullahpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Kuliarchar Osmanpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Kuliarchar Ramdi", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Kuliarchar Salua", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Latibabad", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Latibpur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Mahinanda", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Maij Khapan", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Maria Industrial City", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Maria Union Parishad", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Mirzapur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "MIthamoin", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Mithamoin Boirati", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Mithamoin Dhaki", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Mithamoin Ghagra", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Mithamoin Katkhal", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Mithamoin Kewarjore", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Nandail Chourasta", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Nanuur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Nikli Chhatirchar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Nikli Dampara", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Nikli Gurue", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Nikli Jaraitala", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Nikli Karpasha", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Nikli Singpur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Nilganj Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Nogua", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Ostagram", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Pakundia", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Pakundia Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Pakundia Burdia", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Pakundia Chandipasha", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Pakundia Char Faradi", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Pakundia Egarasindur", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Pakundia Hosendi", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Pakundia Jangalia", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Pakundia Narandi", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Pakundia Patuabhanga", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Pakundia Sukhia", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Patuabhanga Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Pulergaat Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Puran Thana Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Purbo Shoti Bari", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Sadulla Bazar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Sararchar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Sholakia", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Sholakia Area", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Tarail Damiha", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Tarail Dhala", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Tarail Digdair", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Tarail Jawar", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Tarail Rauti", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Tarail Sachail", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Tarail Talganga", "bn_name": "" },
    { "id": "483", "district_id": "139", "name": "Tarial", "bn_name": "" },



    { "id": "483", "district_id": "140", "name": "Adampur", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Arial Khan Ferry Ghat", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Balairkandi", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Charmuguria", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Durgabordi", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Kalkini", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Kazibari", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Khakdi Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Kulpoddi Post Office", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Madaripur Bus Terminal", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Madaripur Police Station", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Madaripur Sadar", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Mostafapur", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Mostafapur Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Panchar", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Puran Bazar", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Rajoir", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Rajoir Khalia", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Sahabrampur", "bn_name": "" },
    { "id": "483", "district_id": "140", "name": "Shibchar", "bn_name": "" },





    { "id": "483", "district_id": "141", "name": "Shibloya Aricha", "bn_name": "" },
    { "id": "483", "district_id": "141", "name": "Shibloya Shibaloy", "bn_name": "" },
    { "id": "483", "district_id": "141", "name": "Shibloya Tewta", "bn_name": "" },
    { "id": "483", "district_id": "141", "name": "Shibloya Uthli", "bn_name": "" },




    { "id": "483", "district_id": "142", "name": "Singair Baira", "bn_name": "" },
    { "id": "483", "district_id": "142", "name": "Singair Basta Stand", "bn_name": "" },
    { "id": "483", "district_id": "142", "name": "Singair Joymantop", "bn_name": "" },
    { "id": "483", "district_id": "142", "name": "Singair Sadar", "bn_name": "" },




    { "id": "483", "district_id": "143", "name": "Baliati", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Barangail", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Betila", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Beutha", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Dashora", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Dautiya", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Gheor", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Gilondo", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Gorpara", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Horirampur", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Joyra", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Kachari", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Mahadebpur", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Manikganj Bazar", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Manikganj Doulatpur", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Manikganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Noyadingi", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Purra", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Rajibpur", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Saturia", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Seutha", "bn_name": "" },
    { "id": "483", "district_id": "143", "name": "Uchutia", "bn_name": "" },




    { "id": "483", "district_id": "144", "name": "Gajaria Hossendi", "bn_name": "" },
    { "id": "483", "district_id": "144", "name": "Gajaria Rasulpur", "bn_name": "" },
    { "id": "483", "district_id": "144", "name": "Gajaria Sadar", "bn_name": "" },
    { "id": "483", "district_id": "144", "name": "Gazaria Anarpur", "bn_name": "" },
    { "id": "483", "district_id": "144", "name": "Gazaria Char Decree", "bn_name": "" },
    { "id": "483", "district_id": "144", "name": "Gazaria Jamaldi", "bn_name": "" },
    { "id": "483", "district_id": "144", "name": "Gazaria Mirergaon", "bn_name": "" },



    { "id": "483", "district_id": "145", "name": "Lohajong", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Lohajong Gouragonj", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Lohajong Haldia SO", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Lohajong Haridia", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Lohajong Haridia DESO", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Lohajong Korhati", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Lohajong Madini Mandal", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Lohajong Medini Mandal EDSO", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Louhajang Atigaon", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Louhajang Bankhira", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Louhajang Dohori", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Louhajang Ghurduwr", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Louhajang Jhaputia", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Louhajang Kahetara", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Louhajang Kalma", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Louhajang Nagerhat Bazar", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Louhajang Pachaldia", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Louhajang Satgharia", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Louhajang Surpara", "bn_name": "" },
    { "id": "483", "district_id": "145", "name": "Louhajang Vorakor", "bn_name": "" },




    { "id": "483", "district_id": "146", "name": "Sirajdikhan", "bn_name": "" },
    { "id": "483", "district_id": "146", "name": "Sirajdikhan Ichapur", "bn_name": "" },
    { "id": "483", "district_id": "146", "name": "Sirajdikhan Kola", "bn_name": "" },
    { "id": "483", "district_id": "146", "name": "Sirajdikhan Malkha Nagar", "bn_name": "" },
    { "id": "483", "district_id": "146", "name": "Sirajdikhan Shekher Nagar", "bn_name": "" },






    { "id": "483", "district_id": "147", "name": "Adhara", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Aparkati", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Autshahi", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Bagahia Kandi", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Baghia", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Baghra", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Bajrajugini", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Bajrozogini", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Baligao", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Bankaij", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Betkahat", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Bhaggyakul", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Chahida Bazar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Char Masura", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Dewbhog Bazar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Dighirpar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Dogachi", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Dulihatta", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "East Shillmandi", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Fultola", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Gonokpara", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Hasail", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Hashail Bazar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Hashara", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Hatimara", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Idrakpur", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Jorpukur Par", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Kata Khali Bazar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Khanka Dalalpara", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Kolapara", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Kumarbhog", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Kurmira", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Lalmiah Bazar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Loharpool", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Maijpara", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Makahati", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Mirkadim", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Moddho Courtgoan", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Motukpur", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Munshiganj Bazar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Munshiganj Notungaon", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Munshiganj Sadar Kathakhali", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Munshiganj Sadar Mirkadim", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Munshiganj Sadar Mukterpur", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Munshiganj Sadar Munshiganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Munshiganj Sadar Rikabibazar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Nalbunya Kandi", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "North Islampur", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Nuraitoli", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Panchgaon Bazar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Panchgharia Kandi", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Parulpara", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Ponchosar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Poschim Manikpur", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Pura", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Pura EDSO", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Rarikhal", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Rikabi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Ronch Moddhopara", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Shilimpur", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Shipahipara", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Sirajdikhan Nimtola", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "South Islampur", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Sreenagar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Sreenagar Damla", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Sreenagar Dogachi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Sreenagar Kolapara Bazar", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Sreenagar Pania", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Sreenagar Tontor", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Svarnagram", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Tangibari", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Tongibari", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Vaggyakul SO", "bn_name": "" },
    { "id": "483", "district_id": "147", "name": "Zapta", "bn_name": "" },



    { "id": "483", "district_id": "148", "name": "Araihazar", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Araihazar Gopaldi", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Baidder Bazar", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Baidder Bazar Bara Nagar", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Baidder Bazar Barodi", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Bandar", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Bandar BIDS", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Bandar D.C Mills", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Fatullah", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Fatullah Bazar", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Madanganj", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Narayanganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Nobiganj", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Rupganj", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Rupganj Bhulta", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Rupganj Kanchan", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Rupganj Murapara", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Rupganj Nagri", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Siddirganj Adamjeenagar", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Siddirganj LN Mills", "bn_name": "" },
    { "id": "483", "district_id": "148", "name": "Siddirganj Siddirganj", "bn_name": "" },
    
    
    
    
    { "id": "483", "district_id": "149", "name": "Basail", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Belabo", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Bilasdi", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Bot-Tola", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Brahmondi", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Charnagardi", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Char Sindhur", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Chinishpur", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Daspara", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Dogoria", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Ghorashal", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Ghorashal Bazar", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Goradia", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Grorashal Pran Factory", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Grorashal Sarkar Khana", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Hazupur", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Janata Jute Mile", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Kandapara", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Karimpur", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Kawriapara", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Madhabdi", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Monohordi", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Monohordi Hatirdia", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Monohordi Katabaria", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Narsingdi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Narsingdi College", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Narsingdi Sadar", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Palash", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Panchdona", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Raypura", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Raypura Bazar Hasnabad", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Raypura Radhaganj bazar", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Saheprotab", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Salidha", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Sarkarkhana", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Satirpara", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Shibpur", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Shilmandi", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Songita", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Torowa", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "UMC Jute Mills", "bn_name": "" },
    { "id": "483", "district_id": "149", "name": "Velanagar", "bn_name": "" },
    
    
    
    
    
    { "id": "483", "district_id": "150", "name": "Bandura", "bn_name": "" },
    { "id": "483", "district_id": "150", "name": "Joypara", "bn_name": "" },
    { "id": "483", "district_id": "150", "name": "Khanepur", "bn_name": "" },
    { "id": "483", "district_id": "150", "name": "Sujapur", "bn_name": "" },




    { "id": "483", "district_id": "151", "name": "Bandura", "bn_name": "" },
    { "id": "483", "district_id": "151", "name": "Joypara", "bn_name": "" },
    { "id": "483", "district_id": "151", "name": "Khanepur", "bn_name": "" },
    { "id": "483", "district_id": "151", "name": "Sujapur", "bn_name": "" },


    
    { "id": "483", "district_id": "152", "name": "Pangsha Mrigibazar", "bn_name": "" },
    { "id": "483", "district_id": "152", "name": "Pangsha Ramkol", "bn_name": "" },
    { "id": "483", "district_id": "152", "name": "Pangsha Ratandia", "bn_name": "" },
    { "id": "483", "district_id": "152", "name": "Pangsha Sadar", "bn_name": "" },





    { "id": "483", "district_id": "153", "name": "Aladipur", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Banibaha", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Bank Para", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Bash Hata", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Beradanga", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Bhabanipur", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Boro Laxmipur", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Choto Bridge Khankhanapur", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Dewan Para", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Doulodia Ghat", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Doulodia Rail Station", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Doulodia Sign Board", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Doulodia Union Boad", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Fire Service Goalanda", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Goalanda Hospital", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Goalanda Mor", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Goalanda Railgate", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Jomider Bridge", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Kazibadha", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Kazikanda", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Kenala Ghat", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Khanapur Notun Bazar", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Khankhanapur", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Kollanpur", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Lokkhikul", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Mallaguti Bridge Goalanda", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Matir Para", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Mondalpara", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Panna Chottor", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Puran Honisova", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Bag Mara", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Bazar", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Binodpur", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Boropul", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Bscic", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari College Para", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Gudar Bazar", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Jailkhana", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Jamtola", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Jutemil", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Notun Para", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Police Line", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Public Health", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Railgate", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Sadar", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Sadar Goalanda", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Sadar Hospital Road", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Sadar Khankhanapur", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Sreepur", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Rajbari Terminal", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Sajankanda", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Surjo Nagar", "bn_name": "" },
    { "id": "483", "district_id": "153", "name": "Vagolpur", "bn_name": "" },
    
    
    
    
    { "id": "483", "district_id": "154", "name": "Ashulia Paragram", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Ashulia Tongabari", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Hemayetpur Jainabari", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Hemayetpur Shampur", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Hemayetpur Tatulzhora Mor", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Jahangirnagar University", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Kashem Cotton Mills", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Rajphulbaria", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Akran Bazaar", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Amin Bazar", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Aralia Bazar Jame Mosjid", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Ashulia Stand", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Baipayl", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Bank Colony", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Bank Town", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Baroipara", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Basp", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Boliarpur", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Cantonment", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Canttonment", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Chakrobarti Stand", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Chandra Stand", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Chapain Road", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Charabag More", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar CRP", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Dairy Farm", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Dhamrai Thana", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Dhulivita Stand", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Enam Medical College", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar EPZ", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Genda", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Gonoshastaya Kendra", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Hemayetpur", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Jamgara", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Kacha Bazar", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Kalampur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Kalampur Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Khagan Bazar", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Nama Bazar", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Narshinghapur", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Nayarhat Stand", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar New Depz", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Nishchintapur Stand", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Nobinagar", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Old Depz", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Polli Biddyut", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Radio Colony", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Rajashon", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Sadar", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Sorkar Market", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Sreepur Stand", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Thana Stand", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Savar Zirabo", "bn_name": "" },
    { "id": "483", "district_id": "154", "name": "Saver P.A.T.C", "bn_name": "" },
    
    
    
    { "id": "483", "district_id": "155", "name": "Naria Bhozeshwar", "bn_name": "" },
    { "id": "483", "district_id": "155", "name": "Naria Gharisar", "bn_name": "" },
    { "id": "483", "district_id": "155", "name": "Naria Kartikpur", "bn_name": "" },
    { "id": "483", "district_id": "155", "name": "Naria Sadar", "bn_name": "" },
    { "id": "483", "district_id": "155", "name": "Naria Upshi", "bn_name": "" },
   
    


    { "id": "483", "district_id": "156", "name": "Bhedorganj", "bn_name": "" },
    { "id": "483", "district_id": "156", "name": "Damudhya", "bn_name": "" },
    { "id": "483", "district_id": "156", "name": "Dashatta", "bn_name": "" },
    { "id": "483", "district_id": "156", "name": "Dhanuka Police Line", "bn_name": "" },
    { "id": "483", "district_id": "156", "name": "Gosairhat", "bn_name": "" },
    { "id": "483", "district_id": "156", "name": "Jajira", "bn_name": "" },
    { "id": "483", "district_id": "156", "name": "Kagdi Bazar", "bn_name": "" },
    { "id": "483", "district_id": "156", "name": "Palong Bazar", "bn_name": "" },
    { "id": "483", "district_id": "156", "name": "Sakhipur", "bn_name": "" },
    { "id": "483", "district_id": "156", "name": "Shariatpur Sadar", "bn_name": "" },
    { "id": "483", "district_id": "156", "name": "Shariatpur Sadar Angaria", "bn_name": "" },
    { "id": "483", "district_id": "156", "name": "Shariatpur Sadar Chikandi", "bn_name": "" },
    { "id": "483", "district_id": "156", "name": "Tulasar", "bn_name": "" },
    
    
    { "id": "483", "district_id": "157", "name": "Bagil", "bn_name": "" },
    { "id": "483", "district_id": "157", "name": "Basail Bazar", "bn_name": "" },
    { "id": "483", "district_id": "157", "name": "Basail Sadar", "bn_name": "" },




    { "id": "483", "district_id": "158", "name": "Arjuna", "bn_name": "" },
    { "id": "483", "district_id": "158", "name": "Bhuapur Sadar", "bn_name": "" },
    { "id": "483", "district_id": "158", "name": "Nikrail", "bn_name": "" },

    
    { "id": "483", "district_id": "159", "name": "Delduar Elasin", "bn_name": "" },
    { "id": "483", "district_id": "159", "name": "Delduar Hinga Nagar", "bn_name": "" },
    { "id": "483", "district_id": "159", "name": "Delduar Jangalia", "bn_name": "" },
    { "id": "483", "district_id": "159", "name": "Delduar Lowhati", "bn_name": "" },
    { "id": "483", "district_id": "159", "name": "Delduar Patharail", "bn_name": "" },
    { "id": "483", "district_id": "159", "name": "Delduar Saddar", "bn_name": "" },
    


    { "id": "483", "district_id": "160", "name": "Baniajan", "bn_name": "" },
    { "id": "483", "district_id": "160", "name": "Dhanbari Sadar", "bn_name": "" },
    { "id": "483", "district_id": "160", "name": "Dhopakhali", "bn_name": "" },


    
    { "id": "483", "district_id": "161", "name": "Ghatail D. Pakutia", "bn_name": "" },
    { "id": "483", "district_id": "161", "name": "Ghatail Dhalapara", "bn_name": "" },
    { "id": "483", "district_id": "161", "name": "Ghatail Lohani", "bn_name": "" },
    { "id": "483", "district_id": "161", "name": "Ghatail Saddar", "bn_name": "" },
    { "id": "483", "district_id": "161", "name": "Ghatail Zahidganj", "bn_name": "" },




    { "id": "483", "district_id": "162", "name": "Gopalpur Chatutia", "bn_name": "" },
    { "id": "483", "district_id": "162", "name": "Gopalpur Hemnagar", "bn_name": "" },
    { "id": "483", "district_id": "162", "name": "Gopalpur Jhowail", "bn_name": "" },
    { "id": "483", "district_id": "162", "name": "Gopalpur Saddar", "bn_name": "" },

    
    { "id": "483", "district_id": "163", "name": "Kalihati Ballabazar", "bn_name": "" },
    { "id": "483", "district_id": "163", "name": "Kalihati Elinga", "bn_name": "" },
    { "id": "483", "district_id": "163", "name": "Kalihati Kalihati", "bn_name": "" },
    { "id": "483", "district_id": "163", "name": "Kalihati Nagarbari", "bn_name": "" },
    { "id": "483", "district_id": "163", "name": "Kalihati Nagarbari SO", "bn_name": "" },
    { "id": "483", "district_id": "163", "name": "Kalihati Nagbari", "bn_name": "" },
    { "id": "483", "district_id": "163", "name": "Kalihati Palisha", "bn_name": "" },
    { "id": "483", "district_id": "163", "name": "Kalihati Rajafair", "bn_name": "" },

    
    
    { "id": "483", "district_id": "164", "name": "Ausnara", "bn_name": "" },
    { "id": "483", "district_id": "164", "name": "Madhupur", "bn_name": "" },
    { "id": "483", "district_id": "164", "name": "Madhupur Dhobari", "bn_name": "" },
    { "id": "483", "district_id": "164", "name": "Sholakuri", "bn_name": "" },

    
    { "id": "483", "district_id": "165", "name": "Mirzapur Gorai", "bn_name": "" },
    { "id": "483", "district_id": "165", "name": "Mirzapur Jarmuki", "bn_name": "" },
    { "id": "483", "district_id": "165", "name": "Mirzapur M.C. College", "bn_name": "" },
    { "id": "483", "district_id": "165", "name": "Mirzapur Mohera", "bn_name": "" },
    { "id": "483", "district_id": "165", "name": "Mirzapur Saddar", "bn_name": "" },
    { "id": "483", "district_id": "165", "name": "Mirzapur Warri paikpara", "bn_name": "" },
    
    
    
    
    { "id": "483", "district_id": "166", "name": "Nagarpur Dhuburia", "bn_name": "" },
    { "id": "483", "district_id": "166", "name": "Nagarpur Sadar", "bn_name": "" },
    { "id": "483", "district_id": "166", "name": "Nagarpur Salimabad", "bn_name": "" },



    
    { "id": "483", "district_id": "167", "name": "Dariapur", "bn_name": "" },
    { "id": "483", "district_id": "167", "name": "Kalmegha", "bn_name": "" },
    { "id": "483", "district_id": "167", "name": "Sakhipur Kochua", "bn_name": "" },
    { "id": "483", "district_id": "167", "name": "Sakhipur Sadar", "bn_name": "" },

    
    
    
    
    { "id": "483", "district_id": "168", "name": "Charabari", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Elanga", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Gala", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Jugni Bazar", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Kasil", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Potol Bazar", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Pugli", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Rosulpur", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Salimpur", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Soto Basail", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Tangail Sadar", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Tangail Sadar Kagmari", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Tangail Sadar Karatia", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Tangail Sadar Porabari", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Tangail Sadar Santosh", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Tarotiya", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Vaita", "bn_name": "" },
    { "id": "483", "district_id": "168", "name": "Vatkora", "bn_name": "" },
   


    
    { "id": "483", "district_id": "169", "name": "27 Bus Stand", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Arichpur", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Badham", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Besic-fokir market", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Besic industrial area", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Beximco", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Bonomala", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Boro bari", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Cherag Ali", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Dewra", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Gazipura", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "International madical", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Jhinu market", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Mail gate", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Mirarbazar", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Mirash para", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Pagar", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Shilmoon", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Shinbari", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Targach", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Tongi bazar", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Tongi Bscic", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Tongi college gate", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Tongi Sadar", "bn_name": "" },
    { "id": "483", "district_id": "169", "name": "Tongi Station Road", "bn_name": "" },
    
    

    
    { "id": "483", "district_id": "170", "name": "Ambari Bazar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Ansar Club", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Asrom Para", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Bahadur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Barapukuria Koylakhoni", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Basuniya Potti", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Bekipul", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "BGB Camp", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Bhushir Bandar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Birampur", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Birol", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Birol Bazar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "BKSP", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Bocaganj", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Boro Gurgola", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Boromath", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Botibabur Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Bottoli Bazar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Bottoli Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Brac Center", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Brtc Road", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Chak Banarasi", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Charubabur More", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Chawliya Potti", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Chehelgazi School", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Chirir Bandar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Chok Bazar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Choto Gurgola", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Chourangi Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Churipotti Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Dabgach Mosque", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Dailar Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Dc Office", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Dinajpur Bus Terminal", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Dinajpur Circuit House", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Dinajpur Education Board", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Dinajpur - Golapganj", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Dinajpur Govt. College", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Dinajpur Palli Biddyut", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Dinajpur Sadar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Dinajpur Technical Training Centre", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Dinajpur Upazila Gate", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Dinajpur Women Govt. College", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Doshmile", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Fakir Para", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Foridpur Gorsthan", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Fulbari", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Fultola Bazar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Gabura Bridge", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Gaocia Gaerege Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Garments Bazar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Gausul Azom Eye Hospital", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Ghasipara", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Ghoraghat", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Golapbag", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Goneshtola", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Gopalgonj Bazar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Gunjabari", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Hili Hakimpur", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Holy Land College", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Holy Land Women Campus", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Hospital Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Housing Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Indra Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Iqbal School Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Islami Hospital", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Jail Road", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Jamtoli Bazar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Jorabridge", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Kalur Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Kana Hafez Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Kanchon Bridge Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "KBM College", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Khaharol", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Khal Para", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Khanpur Bodar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Khansama", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Khetripara", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Khokon Mowlovi Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Kholahati Cantorment", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Kisan Bazar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Kobiraj Hat", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Komolpur", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Kosba", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Kutubdanga Bazzar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Labur Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Lalbag Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Law College Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Maldahpotti", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Mamun Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Masimpur", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Matasagor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Medical College", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Mission Road", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Misson Get", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Mohanpur", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Mohonpur Rabar Dam", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Monggolpur", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Mushipara Jail Road", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Nabil Counter", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Nawabganj", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "New Town 1", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "New Town 2", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "New Town 3", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "New Town 4", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "New Town 5", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Newtown 6", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Newtown 7", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Newtown 8", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Nimtola", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Notun Para", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Noyanpur", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Paglamor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Paharpur", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Paker Hat", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Patua Para", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Police Line Market", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Polytechnical College", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Professor Para", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "PTI Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Rab -13 Camp", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Rail Bazar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Rajbati", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Ramdubi Hat", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Ramnogor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Ramsagor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Raniganj Bazar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Ranirbandar", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Sekhpura", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Setabganj", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Sikdar Hat", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Sohid Minar Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Sostitola", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Staf Quarter Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Tap Biddyut Kendro", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Thana Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Tnt Mor", "bn_name": "" },
    { "id": "483", "district_id": "170", "name": "Zia Heart Foundation", "bn_name": "" },
    
    
    
    
    { "id": "483", "district_id": "171", "name": "Ambari", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Badiakhali", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Baghjana", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Balashi Ghat", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Bara Gayaspur", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Bisramgachi", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Chandipur", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Fulchari Konchi Para", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Gaibandha Sadar", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Gobindaganj Baluyapara", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Gobindaganj Mollapara", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Gobindoganj", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Indira Par", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Jalinge", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Jugibai", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Kanipara", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Kumarpara", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Kuptola", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Masterpara", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Modhdhopara", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Mondolpara", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Nawabganj Pholia", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Palashbari", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Polash Para", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Sadullapur", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Sadullapur Naldanga Union", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Saghata Bonapara Bazar", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Suigram", "bn_name": "" },
    { "id": "483", "district_id": "171", "name": "Sundarganj", "bn_name": "" },
    
    
    
    { "id": "483", "district_id": "172", "name": "Bhogdanga", "bn_name": "" },
    { "id": "483", "district_id": "172", "name": "Bhurungamari", "bn_name": "" },
    { "id": "483", "district_id": "172", "name": "Char Rajibpur", "bn_name": "" },
    { "id": "483", "district_id": "172", "name": "Chilmari", "bn_name": "" },
    { "id": "483", "district_id": "172", "name": "Jatrapur", "bn_name": "" },
    { "id": "483", "district_id": "172", "name": "Kurigram Phulbari", "bn_name": "" },
    { "id": "483", "district_id": "172", "name": "Kurigram Rajarhat", "bn_name": "" },
    { "id": "483", "district_id": "172", "name": "Kurigram Sadar", "bn_name": "" },
    { "id": "483", "district_id": "172", "name": "Nageshwari", "bn_name": "" },
    { "id": "483", "district_id": "172", "name": "Panchgachi", "bn_name": "" },
    { "id": "483", "district_id": "172", "name": "Rangalirbash", "bn_name": "" },
    { "id": "483", "district_id": "172", "name": "Rowmari", "bn_name": "" },
    { "id": "483", "district_id": "172", "name": "Ulipur", "bn_name": "" },
    
    
    
    { "id": "483", "district_id": "173", "name": "Aditmari Bhelabari", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Aditmari Durgapur", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Aditmari Kamlabari", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Aditmari Kashiabarir Hat", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Aditmari Mohiskhocha", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Aditmari Polashi", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Aditmari Saptipari Bazar", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Aditmari Sarpukur", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Aditmari Upazila Parishad", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Balatari Jame Mashjid Lalmonirhat", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Barabari", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Circuit House Lalmonirhat", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Hatibandha Barakhata", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Hatibandha Dauabari", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Hatibandha Goddimari", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Hatibandha Gotamari", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Hatibandha Shinduna", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Kaliganj Bhotmari", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Kaliganj Chandrapur", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Kaliganj Dalagram", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Kaliganj Gorol", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Kaliganj Kakina", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Kaliganj Modati", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Kaliganj Tushvandar", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Kaliganj Vullar Hat", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Lalmonirhat Sadar", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Lalmonirhat Stadium Road", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Noyar hat", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Patgram Baura", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Patgram Burimari", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Patgram Jongra", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Patgram Kawamari Bazar", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Patgram Kuchlibari", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Patgram Munshir Hat", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Patgram Sreerampur", "bn_name": "" },
    { "id": "483", "district_id": "173", "name": "Patgram Thana", "bn_name": "" },
    


    
    { "id": "483", "district_id": "174", "name": "Badia'r Mor", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Chowrongi Mor", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Circuit House Mor", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "College Station", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Dimla Balapara", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Dimla Gayabari", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Dimla Khoga Khoribari", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Dimla Nautara", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Dimla Paschim Chatnai", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Dimla Sadar", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Dimla Shothibari Bazar", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Domar Boragari Bazar", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Domar Gomnati Bazar", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Domar Halhalia", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Domar Sonaray Bazar", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Domar Thana", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Harowa", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Kalitola", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Kishoreganj Check Post Bazar", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Kishoreganj Kalikapur", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Maniker Mor", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Nilphamari - Gobindopur", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Niphamari Kishoreganj Sadar", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Notkhana", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Pouro Market", "bn_name": "" },
    { "id": "483", "district_id": "174", "name": "Railway Station", "bn_name": "" },
    
    
    { "id": "483", "district_id": "175", "name": "Bangalipur", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Cant Bazar", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Golahat Railway Colony", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Hati Kahana", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Kashiram Belpukur", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Kundol", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Nilphamari Sadar", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Saidpur Airport", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Saidpur Bus Terminal", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Saidpur Lakshmanpur", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Saidpur Pach Matha Mor", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Saidpur Plaza", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Saidpur Post Office", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Saidpur Railway Station", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Saidpur Super Market", "bn_name": "" },
    { "id": "483", "district_id": "175", "name": "Wapda Bazar", "bn_name": "" },




    { "id": "483", "district_id": "176", "name": "Atwari", "bn_name": "" },
    { "id": "483", "district_id": "176", "name": "Boda Banagram", "bn_name": "" },
    { "id": "483", "district_id": "176", "name": "Boda Haldibari", "bn_name": "" },
    { "id": "483", "district_id": "176", "name": "Boda Maidandighi", "bn_name": "" },
    { "id": "483", "district_id": "176", "name": "Bp Government High School Hostel Panchagarh", "bn_name": "" },
    { "id": "483", "district_id": "176", "name": "Debigang Thana", "bn_name": "" },
    { "id": "483", "district_id": "176", "name": "Debiganj Dhuajhari Bazar", "bn_name": "" },
    { "id": "483", "district_id": "176", "name": "Debiganj Kaharganj", "bn_name": "" },
    { "id": "483", "district_id": "176", "name": "Docropara", "bn_name": "" },
    { "id": "483", "district_id": "176", "name": "Nimnagar Mosque Panchagarh", "bn_name": "" },
    { "id": "483", "district_id": "176", "name": "Panchagarh Sadar", "bn_name": "" },
    { "id": "483", "district_id": "176", "name": "Tetulia", "bn_name": "" },
    
    


    
    
    { "id": "483", "district_id": "177", "name": "Adarsopara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Alamnagar Road", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Ansari Mor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Arshad Nagor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Asrotpur", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Babukha", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Badarganj", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Badarganj Sahidminar", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Bangladesh Bank Mor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Barabil Gangachara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Beacon Mor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Betpotti", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Birganj", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Boiragi Para", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Bokultola", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Borobari", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Boubazar", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Burirhat", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "C.M.B Quarter", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "C.O Bazar", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Central Road", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Charokbari", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Chartola Mor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Chatra", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Checkpost 3 Numbar", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Chirirbandar", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Circuit House Lane", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "City Bazar", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "D.C Mor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Deodoba", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Dhap Engineer Para", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Dhaperhut Palichara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Dhap Haji Para", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Dhap Masterpara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Dhap Sagor Para", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Dhap Sardar Para", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Dharsona", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Dr. Wazed Miah Textile Engineering College", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Gamostopara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Ghunjonmor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Gl Roy Road", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Gonespur", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Grand Hotel Mor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Guptopara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Gurati Para", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Habibnagar Akhalitari", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Hanumantola", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Haragach", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Horidebpur", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Indrarmore", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Jaldhaka Nilphamari", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Jalkor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Jummapara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Jummapara Pakarmatha", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Kachari Bazar", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Kakoli Lane", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Kamalkachna", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Kamarpara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Karuponno Alamnagor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Katki Para", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Kaunia", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Kellaband", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Kerani Para", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Khamar Mor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Khasbag", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Kobaru", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Kukrul Golakatamor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Lalkuti Lane", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Lohaqusi Shukurer Hat", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Madarganj", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Mahigonj", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Medical Pakarmatha", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Medical Purbo Gate", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Medical Quater", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Milonpara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Mithapukur", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Mohadevpur", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Mondol Para", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Mordern", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Mulatol", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Munsipara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Nazirrerhat", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "New Jummapara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "New Shahebganj", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Nil Kantho", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Nisbedganj", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Noyatola Saidpur", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Nurpur", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Paglapir", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Pairaband", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Palpara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Parkmor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Pasari Para", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Payra Chattar", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Pirgacha", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Pirganj", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Pirpur", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Pouro Bazar", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Poyradanga Nageswari", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Press Club", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Prime Medical", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Radhaballav", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Rail Station", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Ramchandrapur Bazar", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Rangpur Cadet College", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Rangpur Cantontment", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Rangpur Medical Pakar Matha", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Rangpur Sadar", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Raypur", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Rcc Mor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Rfl Foundary", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "RK Road", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Robertsongonj", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Salbon Mistripara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Sardarpara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Satmatha", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Senpara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Shampur Road", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Shapla", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Shayamoli Lane", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Shimulbag", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Shukurer Hat", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Siyalurmor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Sultanmor", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Super Market", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Tajhat", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Taraganj", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Tati Para", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Thikadarpara", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Uttom Hajirhat", "bn_name": "" },
    { "id": "483", "district_id": "177", "name": "Vogi Lane", "bn_name": "" },
    
    
    
    
    
    { "id": "483", "district_id": "178", "name": "BADC Staff Quarter", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Baliadangi", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Baliadangi Ruhia", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Border Guard Bangladesh", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "College Para", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Goalpara", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Gobindo Nogor Mondir Para", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Goreya", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Goshpara", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Hazipara", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Islambag", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Jamidarpara", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Kalitola Bazar", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Khalpara", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Nishchintapur", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Ranisankail Durlovpur", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Ranisankail Mirdangi", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Ranisankail Rajbari", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Sarakar Para", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Thakurgaon - Haripur", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Thakurgaon - Munshipara", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Thakurgaon - Pirganj", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Thakurgaon Sadar", "bn_name": "" },
    { "id": "483", "district_id": "178", "name": "Thakurgaon - Tatipara", "bn_name": "" },
    



    { "id": "483", "district_id": "179", "name": "Dewangonj Dewangonj S. Mills", "bn_name": "" },
    { "id": "483", "district_id": "179", "name": "Dewangonj Sadar", "bn_name": "" },
    

    
    { "id": "483", "district_id": "180", "name": "Islampur Durmoot", "bn_name": "" },
    { "id": "483", "district_id": "180", "name": "Islampur Gilabari", "bn_name": "" },
    { "id": "483", "district_id": "180", "name": "Islampur Sadar", "bn_name": "" },

    
    { "id": "483", "district_id": "181", "name": "Madarganj Balijhuri", "bn_name": "" },
    { "id": "483", "district_id": "181", "name": "Madarganj Sadar", "bn_name": "" },

    
    
    
    
    { "id": "483", "district_id": "182", "name": "Malandah Jamalpur", "bn_name": "" },
    { "id": "483", "district_id": "182", "name": "Malandah Mahmoodpur", "bn_name": "" },
    { "id": "483", "district_id": "182", "name": "Malandah Malancha", "bn_name": "" },
    { "id": "483", "district_id": "182", "name": "Malandah Sadar", "bn_name": "" },
    
    
    
    
    { "id": "483", "district_id": "183", "name": "Madarganj Adarvita", "bn_name": "" },
    { "id": "483", "district_id": "183", "name": "Shorishabari Bausee", "bn_name": "" },
    { "id": "483", "district_id": "183", "name": "Shorishabari Jagannath Ghat", "bn_name": "" },
    { "id": "483", "district_id": "183", "name": "Shorishabari Jamuna Sar Karkhana", "bn_name": "" },
    { "id": "483", "district_id": "183", "name": "Shorishabari Pingna", "bn_name": "" },
    { "id": "483", "district_id": "183", "name": "Shorishabari Shorishabari", "bn_name": "" },
    
    
    { "id": "483", "district_id": "184", "name": "Beltia", "bn_name": "" },
    { "id": "483", "district_id": "184", "name": "Bhabki", "bn_name": "" },
    { "id": "483", "district_id": "184", "name": "Charpolisha", "bn_name": "" },
    { "id": "483", "district_id": "184", "name": "Jamalpur Bus Terminal", "bn_name": "" },
    { "id": "483", "district_id": "184", "name": "Jamalpur Court", "bn_name": "" },
    { "id": "483", "district_id": "184", "name": "Jamalpur Nandina", "bn_name": "" },
    { "id": "483", "district_id": "184", "name": "Jamalpur Narundi", "bn_name": "" },
    { "id": "483", "district_id": "184", "name": "Jamalpur Railway Station", "bn_name": "" },
    { "id": "483", "district_id": "184", "name": "Jamalpur Sadar", "bn_name": "" },
    { "id": "483", "district_id": "184", "name": "Jamalpur Shantinagar", "bn_name": "" },
    { "id": "483", "district_id": "184", "name": "Khoshmahal", "bn_name": "" },
    { "id": "483", "district_id": "184", "name": "Shekhervita", "bn_name": "" },
    { "id": "483", "district_id": "184", "name": "Shihata", "bn_name": "" },
    
    
    
    { "id": "483", "district_id": "185", "name": "Gaforgaon Duttarbazar", "bn_name": "" },
    { "id": "483", "district_id": "185", "name": "Gaforgaon Kandipara", "bn_name": "" },
    { "id": "483", "district_id": "185", "name": "Gaforgaon Sadar", "bn_name": "" },
    { "id": "483", "district_id": "185", "name": "Gaforgaon Shibganj", "bn_name": "" },
    { "id": "483", "district_id": "185", "name": "Gaforgaon Usti", "bn_name": "" },
    

    
    { "id": "483", "district_id": "186", "name": "Gouripur Ramgopalpur", "bn_name": "" },
    { "id": "483", "district_id": "186", "name": "Gouripur Sadar", "bn_name": "" },
    

    
    
    { "id": "483", "district_id": "187", "name": "Haluaghat Dhara", "bn_name": "" },
    { "id": "483", "district_id": "187", "name": "Haluaghat Munshirhat", "bn_name": "" },
    { "id": "483", "district_id": "187", "name": "Haluaghat Sadar", "bn_name": "" },
    
    
    
    { "id": "483", "district_id": "188", "name": "Isshwargonj Atharabari", "bn_name": "" },
    { "id": "483", "district_id": "188", "name": "Isshwargonj Isshwargonj", "bn_name": "" },
    { "id": "483", "district_id": "188", "name": "Isshwargonj Sohagi", "bn_name": "" },



    { "id": "483", "district_id": "189", "name": "Bahenga", "bn_name": "" },
    { "id": "483", "district_id": "189", "name": "Muktagachha Sadar", "bn_name": "" },
    { "id": "483", "district_id": "189", "name": "Palgaon", "bn_name": "" },


    
    { "id": "483", "district_id": "190", "name": "Nandail Gangail", "bn_name": "" },
    { "id": "483", "district_id": "190", "name": "Nandail Sadar", "bn_name": "" },

    
    { "id": "483", "district_id": "191", "name": "Phulpur Beltia", "bn_name": "" },
    { "id": "483", "district_id": "191", "name": "Phulpur Phulpur", "bn_name": "" },
    { "id": "483", "district_id": "191", "name": "Phulpur Tarakanda", "bn_name": "" },

    
    { "id": "483", "district_id": "192", "name": "Akua", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "Bhaluka", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "C.K. Gosh Road", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "Chorpara Area", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "Fulbaria Asim", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "Maskanda Bypass", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "Mymensingh Sadar", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "Mymensingh Sadar Agriculture Universi", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "Mymensingh Sadar Biddyaganj", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "Mymensingh Sadar Kawatkhali", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "Mymensingh Sadar Shombhuganj", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "Mymensingh Zero Point", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "Rahamatpur Engineering College", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "Sankipara Jamtola Ses More", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "Tarakanda Bazar", "bn_name": "" },
    { "id": "483", "district_id": "192", "name": "Trishal Kabi Nazrul University", "bn_name": "" },
    
    
    { "id": "483", "district_id": "193", "name": "Trishal Ahmadbad", "bn_name": "" },
    { "id": "483", "district_id": "193", "name": "Trishal Dhala", "bn_name": "" },
    { "id": "483", "district_id": "193", "name": "Trishal Ram Amritaganj", "bn_name": "" },
    { "id": "483", "district_id": "193", "name": "Trishal Saddar", "bn_name": "" },



    { "id": "483", "district_id": "194", "name": "Atpara", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Barhatta", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Dharmapasha", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Dhobaura", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Dhobaura Sakoai", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Kalmakanda", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Kendua", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Khaliajuri Saddar", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Khaliajuri Shaldigha", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Madan Madan", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Moddhynagar Moddoynagar", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Mohanganj", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Netrakona Sadar", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Netrakona Sadar Baikherhati", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Pachkahonia", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Purbadhola Jaria Jhanjhail", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Purbadhola Saddar", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Purbadhola Shamgonj", "bn_name": "" },
    { "id": "483", "district_id": "194", "name": "Susung Durgapur", "bn_name": "" },
    
    
    
    { "id": "483", "district_id": "195", "name": "Akheri Bazar", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Astomi Tola", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Bakshigonj Bakshigonj", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Bazit Khila", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Boira Puran Pur", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Chakpathak", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Chapatoli", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Chowrasta More", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Dhakolhati", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Durga Narayan Pur", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Garial Bari", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Gouripur", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Gowalpotti", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Gridda Narayanpur", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Jhinaigati", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Khowarpar", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Kushum Hati", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Methor Potti", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Moddho Sheri", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Nabaron School", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Nakla", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Nakla Gonopaddi", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Nalitabari", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Nalitabari Hatibandha", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Nayanibazar", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Nazira Bag Bazar", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Puraton Goru Hati", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Rajbollobpur", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Rangmahal", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Rogunath Bazar", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Shajbor Khila", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Shekh Hati", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sheri Bridge", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur Bagbari", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur Bot Tola", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur College Mor", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur Jailkhana Mor", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur Kalibari", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur Kaliganj", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur Kasba", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur Mirganj", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur New Market", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur Nobinagar", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur Nowhata", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur Sadar Hospital", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur Shadar", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur Thana Mor", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur Truck Station", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Sherpur Wireless Mor", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Shib Bari", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Shingpara", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Shitolpur", "bn_name": "" },
    { "id": "483", "district_id": "195", "name": "Shribardi Shribardi", "bn_name": "" },
    

];
export default Upazilas;